<template>
    <div v-cloak>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'informes' }">{{ $t("informes") }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{ $t("analisisNegocio") }}</li>
                    </ol>
                </nav>
            </div>

            <!-- Filtros -->
            <div class="col-md-12">
                <div class="card an-filtros">
                    <div class="an-filtros-fila">
                        <div class="an-filtro an-filtro-empresa">
                            <label>{{ $t("empresa") }}</label>
                            <select class="form-control" v-model="idCompany" @change="onCompanyChange">
                                <option v-for="c in listCompanies" :key="c.id" :value="c.id">{{ c.name }}</option>
                            </select>
                        </div>

                        <div v-if="modoSectores" class="an-filtro an-filtro-negocios">
                            <label>{{ $t("sector") }}</label>
                            <el-select v-model="idSector" filterable class="an-select" :placeholder="$t('seleccionaSector')">
                                <el-option v-for="sc in sectoresEmpresa" :key="sc.id" :label="sc.name" :value="sc.id" />
                            </el-select>
                        </div>
                        <div v-else class="an-filtro an-filtro-negocios">
                            <label>{{ $t("negocios") }}</label>
                            <el-select v-model="idsBusiness" multiple collapse-tags clearable class="an-select" :placeholder="$t('todaLaEmpresa')">
                                <el-option v-for="b in listBusinesses" :key="b.id" :label="b.establishmentName" :value="b.id" />
                            </el-select>
                        </div>

                        <div class="an-filtro an-filtro-modo">
                            <label>{{ $t("anPeriodo") }}</label>
                            <div class="btn-group an-modo">
                                <button type="button" class="btn btn-sm" :class="modo === 'mes' ? 'btn-primary btn-fill' : 'btn-default'" @click="modo = 'mes'">{{ $t("anModoMes") }}</button>
                                <button type="button" class="btn btn-sm" :class="modo === 'rango' ? 'btn-primary btn-fill' : 'btn-default'" @click="modo = 'rango'">{{ $t("anModoRango") }}</button>
                                <button type="button" class="btn btn-sm" :class="modo === 'anio' ? 'btn-primary btn-fill' : 'btn-default'" @click="modo = 'anio'">{{ $t("anModoAnio") }}</button>
                            </div>
                        </div>

                        <!-- Modo mes -->
                        <template v-if="modo === 'mes'">
                            <div class="an-filtro an-filtro-mes">
                                <label>{{ $t("anMes") }}</label>
                                <input type="month" class="form-control" v-model="mesA" :max="mesActual" />
                            </div>
                            <div class="an-filtro an-filtro-comparar">
                                <label>{{ $t("anCompararCon") }}</label>
                                <select class="form-control" v-model="compararMes">
                                    <option value="ambos">{{ $t("anMesAnteriorYAnioAnterior") }}</option>
                                    <option value="anterior">{{ $t("anMesAnterior") }}</option>
                                    <option value="anioAnterior">{{ $t("anMismoMesAnioAnterior") }}</option>
                                    <option value="ninguno">{{ $t("anSinComparar") }}</option>
                                </select>
                            </div>
                        </template>

                        <!-- Modo rango -->
                        <template v-if="modo === 'rango'">
                            <div class="an-filtro an-filtro-rango">
                                <label>{{ $t("anPeriodoA") }}</label>
                                <div class="an-rango">
                                    <input type="month" class="form-control" v-model="rangoA.desde" :max="mesActual" />
                                    <span>–</span>
                                    <input type="month" class="form-control" v-model="rangoA.hasta" :max="mesActual" />
                                </div>
                            </div>
                            <div class="an-filtro an-filtro-rango">
                                <label>{{ $t("anPeriodoB") }} <small class="text-muted">({{ $t("opcional") }})</small></label>
                                <div class="an-rango">
                                    <input type="month" class="form-control" v-model="rangoB.desde" :max="mesActual" />
                                    <span>–</span>
                                    <input type="month" class="form-control" v-model="rangoB.hasta" :max="mesActual" />
                                </div>
                            </div>
                        </template>

                        <!-- Modo año -->
                        <template v-if="modo === 'anio'">
                            <div class="an-filtro an-filtro-mes">
                                <label>{{ $t("anAnio") }}</label>
                                <select class="form-control" v-model="anioA">
                                    <option v-for="a in aniosDisponibles" :key="a" :value="a">{{ a }}</option>
                                </select>
                            </div>
                            <div class="an-filtro an-filtro-comparar">
                                <label>{{ $t("anCompararCon") }}</label>
                                <select class="form-control" v-model="compararAnio">
                                    <option value="anterior">{{ $t("anAnioAnteriorMismaFecha") }}</option>
                                    <option value="ninguno">{{ $t("anSinComparar") }}</option>
                                </select>
                            </div>
                        </template>

                        <div class="an-filtro an-filtro-accion">
                            <button class="btn btn-primary btn-fill" :disabled="cargando || !puedeConsultar" @click="consultar(false)">
                                <i class="fa fa-search"></i> {{ $t("consultar") }}
                            </button>
                            <!-- Recalcular: escalonado (uno por hora, tres al día) salvo developerView; mientras, se enseña la espera -->
                            <button class="btn btn-default an-btn-recalcular" :class="{ 'an-btn-recalcular-espera': recalculoEspera > 0 }"
                                :disabled="cargando || !consultado || recalculando || recalculoEspera > 0" @click="recalcular()"
                                v-tooltip.top-center="recalculoEspera > 0 ? $i18n.t(recalculoMotivo === 'dia' ? 'anRecalcularEsperaDia' : 'anRecalcularEspera', { tiempo: textoEsperaRecalculo }) : $i18n.t('anRecalcularAyuda')">
                                <i class="fas fa-sync-alt" :class="{ 'fa-spin': recalculando }"></i><span v-if="recalculoEspera > 0" class="an-recalcular-espera"> {{ textoEsperaRecalculo }}</span>
                            </button>
                        </div>
                    </div>

                    <div v-if="errorPeriodo" class="an-nota an-nota-error"><i class="fas fa-exclamation-circle"></i> {{ errorPeriodo }}</div>
                    <div v-else class="an-nota">
                        <i class="fas fa-info-circle"></i> {{ resumenPeriodos }}
                        <template v-if="cacheInfo"> · {{ cacheInfo }}</template>
                    </div>
                    <!-- La API pone siempre como A el periodo más reciente: si se pidió al revés, se avisa -->
                    <div v-if="periodosReordenados" class="an-nota an-nota-aviso">
                        <i class="fas fa-exchange-alt"></i> {{ $t("anPeriodosReordenados", { reciente: etiquetaCorta('A'), antiguo: etiquetaCorta(clavesComparadas[0]) }) }}
                    </div>
                </div>
            </div>

            <!-- Cargando -->
            <div class="col-md-12" v-if="cargando">
                <div class="card an-cargando"><i class="fa fa-spinner fa-spin"></i> {{ $t("anCalculandoPeriodos") }}</div>
            </div>

            <!-- Sin datos -->
            <div class="col-md-12" v-if="consultado && !cargando && !tieneDatos">
                <div class="card an-vacio">
                    <div class="an-vacio-icono"><i class="fas fa-chart-line"></i></div>
                    <h4>{{ $t("anSinDatos") }}</h4>
                    <p>{{ $t("anSinDatosTexto") }}</p>
                </div>
            </div>

            <template v-if="consultado && !cargando && tieneDatos">
                <!-- KPIs -->
                <div class="col-md-12">
                    <div class="an-kpis">
                        <div v-for="k in kpiCards" :key="k.clave" class="card an-kpi">
                            <div class="an-kpi-titulo">{{ $t(k.etiqueta) }}</div>
                            <div class="an-kpi-valor">{{ formatear(kpis.A[k.clave], k.tipo) }}</div>
                            <div class="an-kpi-comparativas">
                                <div v-for="clave in clavesComparadas" :key="k.clave + clave" class="an-kpi-var"
                                    :class="claseVariacion(k, variacionKpi(k, clave))">
                                    <i class="fas" :class="iconoVariacion(variacionKpi(k, clave))"></i>
                                    <span class="an-kpi-var-valor">{{ formatearVariacion(variacionKpi(k, clave)) }}</span>
                                    <span class="an-kpi-var-etiqueta">{{ etiquetaCorta(clave) }} · {{ formatear(kpis[clave][k.clave], k.tipo) }}</span>
                                </div>
                            </div>
                            <div v-if="k.nota && comparativas[clavesComparadas[0]] && !comparativas[clavesComparadas[0]].mismaLongitud" class="an-kpi-nota">
                                {{ $t("anPeriodosDistintaLongitud") }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Pestañas -->
                <div class="col-md-12">
                    <div class="card an-pestanas-card">
                        <div class="an-pestanas">
                            <button type="button" class="an-pestana" :class="{ activa: pestana === 'ventas' }" @click="pestana = 'ventas'">
                                <i class="fas fa-chart-bar"></i> {{ $t("anPestanaVentas") }}
                            </button>
                            <button type="button" class="an-pestana" :class="{ activa: pestana === 'formasPago' }" @click="pestana = 'formasPago'">
                                <i class="fas fa-credit-card"></i> {{ $t("anPestanaFormasPago") }}
                            </button>
                            <button type="button" class="an-pestana" :class="{ activa: pestana === 'incidencias' }" @click="pestana = 'incidencias'">
                                <i class="fas fa-exclamation-triangle"></i> {{ $t("anPestanaIncidencias") }}
                            </button>
                            <button type="button" class="an-pestana" :class="{ activa: pestana === 'rentabilidad' }" @click="pestana = 'rentabilidad'">
                                <i class="fas fa-coins"></i> {{ $t("anPestanaRentabilidad") }}
                            </button>
                            <!-- Exportar: los botones nunca van disabled (un botón disabled no recibe hover ni tooltip);
                                 si la pestaña aún no ha cargado, exportar() lo explica con un aviso -->
                            <div class="an-exportar">
                                <button type="button" class="btn btn-sm an-btn-pdf" :class="{ 'an-btn-inactivo': !pestanaCargada || exportando }" @click="exportar('PDF')"
                                    v-tooltip.top-center="$i18n.t('anExportarPdfAyuda')">
                                    <i class="fas" :class="exportando === 'PDF' ? 'fa-spinner fa-spin' : 'fa-file-pdf'"></i> PDF
                                </button>
                                <button type="button" class="btn btn-sm an-btn-excel" :class="{ 'an-btn-inactivo': !pestanaCargada || exportando }" @click="exportar('Excel')"
                                    v-tooltip.top-center="$i18n.t('anExportarExcelAyuda')">
                                    <i class="fas" :class="exportando === 'Excel' ? 'fa-spinner fa-spin' : 'fa-file-excel'"></i> Excel
                                </button>
                            </div>
                        </div>

                        <!-- Pestaña Ventas -->
                        <div v-if="pestana === 'ventas'" class="an-pestana-cuerpo">
                            <div class="an-graficas">
                                <div class="an-grafica an-grafica-ancha">
                                    <div class="an-grafica-cabecera">
                                        <h5>{{ $t("anEvolucionMensual") }} <small class="text-muted">{{ $t("anUltimos13Meses") }}</small></h5>
                                        <div class="an-grafica-opciones">
                                            <select class="form-control input-sm" v-model="metricaEvolucion" @change="pintarEvolucion()">
                                                <option value="ventas">{{ $t("ventas") }}</option>
                                                <option value="documentos">{{ $t("numDocumentos") }}</option>
                                                <option value="ticketMedio">{{ $t("ticketMedio") }}</option>
                                                <option value="mediaDiaria">{{ $t("anMediaDiaria") }}</option>
                                                <option value="incidencias">{{ $t("incidencias") }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="an-canvas">
                                        <canvas ref="canvasEvolucion"></canvas>
                                        <div v-if="cargandoEvolucion" class="an-grafica-cargando"><i class="fa fa-spinner fa-spin"></i> {{ $t("anCalculandoMesesAntiguos") }}</div>
                                    </div>
                                </div>

                                <div class="an-grafica an-grafica-ancha">
                                    <div class="an-grafica-cabecera">
                                        <h5>{{ $t("anVentasPorDia") }}</h5>
                                        <div class="an-grafica-opciones">
                                            <label class="an-check">
                                                <input type="checkbox" v-model="alinearSemana" @change="cargarVentas()" /> {{ $t("anAlinearPorDiaSemana") }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="an-canvas">
                                        <canvas ref="canvasDiario"></canvas>
                                        <div v-if="cargandoVentas" class="an-grafica-cargando"><i class="fa fa-spinner fa-spin"></i> {{ $t("cargando") }}</div>
                                    </div>
                                    <div v-if="ventas && ventas.notas.length" class="an-notas-grafica">
                                        <span v-for="n in ventas.notas" :key="n" class="an-badge">{{ textoNota(n) }}</span>
                                    </div>
                                </div>

                                <div class="an-grafica">
                                    <div class="an-grafica-cabecera">
                                        <h5>{{ $t("anVentasPorDiaSemana") }} <small class="text-muted">{{ $t("anMediaPorDiaConVentas") }}</small></h5>
                                    </div>
                                    <div class="an-canvas"><canvas ref="canvasSemana"></canvas></div>
                                </div>

                                <div class="an-grafica">
                                    <div class="an-grafica-cabecera">
                                        <h5>{{ $t("anVentasPorHora") }}</h5>
                                    </div>
                                    <div class="an-canvas"><canvas ref="canvasHoras"></canvas></div>
                                </div>
                            </div>

                            <!-- Tabla por negocio / TPV -->
                            <h5 class="an-titulo-tabla">{{ $t("anPorNegocioYTpv") }}</h5>
                            <div class="an-scroll" v-if="ventas">
                                <table class="table table-bordered table-hover an-tabla">
                                    <thead>
                                        <tr>
                                            <th>{{ $t("negocio") }}</th>
                                            <th>{{ $t("tpv") }}</th>
                                            <th v-for="clave in clavesPeriodos" :key="'th-v-' + clave" class="text-right">{{ $t("ventas") }} <small>{{ etiquetaCorta(clave) }}</small></th>
                                            <th v-if="clavesComparadas.length" class="text-right" v-tooltip.top-center="textoDireccionVariacion">{{ $t("anVariacion") }} <small>{{ etiquetaCorta(clavesComparadas[0]) }} → {{ etiquetaCorta('A') }}</small></th>
                                            <th v-for="clave in clavesPeriodos" :key="'th-d-' + clave" class="text-right">{{ $t("numDocumentos") }} <small>{{ etiquetaCorta(clave) }}</small></th>
                                            <th v-for="clave in clavesPeriodos" :key="'th-t-' + clave" class="text-right">{{ $t("ticketMedio") }} <small>{{ etiquetaCorta(clave) }}</small></th>
                                            <th class="text-right">{{ $t("anMediaDiaria") }} <small>{{ etiquetaCorta('A') }}</small></th>
                                            <th class="text-right">{{ $t("sesiones") }} <small>{{ etiquetaCorta('A') }}</small></th>
                                            <th class="text-right">{{ $t("incidencias") }} <small>{{ etiquetaCorta('A') }}</small></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="fila in filasTabla" :key="'f-' + fila.idTpv" :class="{ 'an-fila-sin-datos': fila.sinDatos }">
                                            <td>{{ fila.nombreNegocio }}</td>
                                            <td>{{ fila.nombreTpv }}</td>
                                            <td v-for="clave in clavesPeriodos" :key="'v-' + fila.idTpv + clave" class="text-right">{{ formatear(fila.periodos[clave].ventas, 'importe') }}</td>
                                            <td v-if="clavesComparadas.length" class="text-right" :class="claseVariacion(kpiVentas, fila.variacion ? fila.variacion.ventas.variacion : null)">
                                                {{ fila.variacion ? formatearVariacion(fila.variacion.ventas.variacion) : '' }}
                                            </td>
                                            <td v-for="clave in clavesPeriodos" :key="'d-' + fila.idTpv + clave" class="text-right">{{ fila.periodos[clave].documentos }}</td>
                                            <td v-for="clave in clavesPeriodos" :key="'t-' + fila.idTpv + clave" class="text-right">{{ formatear(fila.periodos[clave].ticketMedio, 'importe') }}</td>
                                            <td class="text-right">{{ formatear(fila.periodos.A.mediaDiaria, 'importe') }}</td>
                                            <td class="text-right">{{ fila.periodos.A.sesiones }}</td>
                                            <td class="text-right">{{ fila.periodos.A.incidencias }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr class="an-fila-total">
                                            <td colspan="2">{{ $t("total") }}</td>
                                            <td v-for="clave in clavesPeriodos" :key="'tv-' + clave" class="text-right">{{ formatear(kpis[clave].ventas, 'importe') }}</td>
                                            <td v-if="clavesComparadas.length" class="text-right" :class="claseVariacion(kpiVentas, variacionKpi(kpiVentas, clavesComparadas[0]))">
                                                {{ formatearVariacion(variacionKpi(kpiVentas, clavesComparadas[0])) }}
                                            </td>
                                            <td v-for="clave in clavesPeriodos" :key="'td-' + clave" class="text-right">{{ kpis[clave].documentos }}</td>
                                            <td v-for="clave in clavesPeriodos" :key="'tt-' + clave" class="text-right">{{ formatear(kpis[clave].ticketMedio, 'importe') }}</td>
                                            <td class="text-right">{{ formatear(kpis.A.mediaDiaria, 'importe') }}</td>
                                            <td class="text-right">{{ kpis.A.sesiones }}</td>
                                            <td class="text-right">{{ kpis.A.incidencias }}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>

                        <!-- Pestaña Formas de pago -->
                        <div v-if="pestana === 'formasPago'" class="an-pestana-cuerpo">
                            <div v-if="cargandoFormasPago" class="an-cargando"><i class="fa fa-spinner fa-spin"></i> {{ $t("cargando") }}</div>
                            <template v-else-if="formasPago">
                                <div v-if="formasPago.corteNoAplicado" class="an-nota an-nota-aviso"><i class="fas fa-info-circle"></i> {{ $t("anFormasPagoMesesCompletos") }}</div>
                                <div class="an-graficas">
                                    <div class="an-grafica">
                                        <div class="an-grafica-cabecera"><h5>{{ $t("anRepartoPorTipo") }} <small class="text-muted">{{ etiquetaCorta('A') }}</small></h5></div>
                                        <div class="an-canvas"><canvas ref="canvasFpDonut"></canvas></div>
                                    </div>
                                    <div class="an-grafica">
                                        <div class="an-grafica-cabecera"><h5>{{ $t("anTiposPorPeriodo") }}</h5></div>
                                        <div class="an-canvas"><canvas ref="canvasFpTipos"></canvas></div>
                                    </div>
                                    <div class="an-grafica an-grafica-ancha">
                                        <div class="an-grafica-cabecera">
                                            <h5>{{ $t("anEvolucionFormasPago") }} <small class="text-muted">{{ $t("anUltimos13Meses") }}</small></h5>
                                            <div class="an-grafica-opciones">
                                                <label class="an-check"><input type="checkbox" v-model="fpEvolucionPorcentaje" @change="pintarFpEvolucion()" /> {{ $t("anEnPorcentaje") }}</label>
                                            </div>
                                        </div>
                                        <div class="an-canvas"><canvas ref="canvasFpEvolucion"></canvas></div>
                                    </div>
                                </div>

                                <h5 class="an-titulo-tabla">{{ $t("anPorTipoYMedio") }}</h5>
                                <div class="an-scroll">
                                    <table class="table table-bordered table-hover an-tabla">
                                        <thead>
                                            <tr>
                                                <th>{{ $t("formaPago") }}</th>
                                                <th v-for="col in columnasPeriodoDobles" :key="'fp-' + col.tipo + col.clave" class="text-right">
                                                    {{ col.tipo === 'a' ? $t("importe") : '%' }} <small>{{ etiquetaCorta(col.clave) }}</small>
                                                </th>
                                                <th v-if="clavesComparadas.length" class="text-right" v-tooltip.top-center="textoDireccionVariacion">{{ $t("anVariacion") }} <small>{{ etiquetaCorta(clavesComparadas[0]) }} → {{ etiquetaCorta('A') }}</small></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="fila in formasPago.tabla" :key="fila.clave" :class="['an-fp-nivel-' + fila.nivel, { 'an-fila-total': fila.nivel === 0 }]">
                                                <td>
                                                    <template v-if="fila.nivel === 0">{{ $t("total") }}</template>
                                                    <template v-else-if="fila.nivel === 1">{{ etiquetaTipoPago(fila.tipo) }}</template>
                                                    <template v-else>
                                                        {{ fila.nombre }}
                                                        <span v-if="fila.specialType" class="an-badge an-badge-especial">{{ etiquetaSpecial(fila.specialType) }}</span>
                                                    </template>
                                                </td>
                                                <td v-for="col in columnasPeriodoDobles" :key="'fp-' + fila.clave + col.tipo + col.clave" class="text-right" :class="{ 'an-pct': col.tipo === 'b' }">
                                                    <template v-if="col.tipo === 'a'">{{ formatear(fila.periodos[col.clave].importe, 'importe') }}</template>
                                                    <template v-else>{{ fila.periodos[col.clave].porcentaje === null ? '–' : formatearPct(fila.periodos[col.clave].porcentaje) }}</template>
                                                </td>
                                                <td v-if="clavesComparadas.length" class="text-right" :class="claseVariacion(kpiVentas, fila.variacion)">{{ formatearVariacion(fila.variacion) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <p class="an-pie">{{ $t("anPorcentajeMediosNota") }}</p>
                            </template>
                        </div>

                        <!-- Pestaña Incidencias -->
                        <div v-if="pestana === 'incidencias'" class="an-pestana-cuerpo">
                            <div v-if="cargandoIncidencias" class="an-cargando"><i class="fa fa-spinner fa-spin"></i> {{ $t("cargando") }}</div>
                            <template v-else-if="incidencias">
                                <div class="an-kpis an-kpis-pestana">
                                    <div v-for="clave in clavesPeriodos" :key="'ik-' + clave" class="card an-kpi">
                                        <div class="an-kpi-titulo">{{ etiquetaCorta(clave) }}</div>
                                        <div class="an-kpi-valor">{{ formatear(incidencias.resumen[clave].total, 'entero') }} <small>{{ $t("incidencias").toLowerCase() }}</small></div>
                                        <div class="an-kpi-sub">{{ $t("anRatioIncidencias", { n: formatearDecimal(incidencias.resumen[clave].ratio) }) }}</div>
                                        <div v-if="clave !== 'A' && incidencias.comparativas[clave]" class="an-kpi-comparativas">
                                            <div class="an-kpi-var" :class="claseVariacion(kpiIncidencias, incidencias.comparativas[clave].ratio.variacion)">
                                                <i class="fas" :class="iconoVariacion(incidencias.comparativas[clave].ratio.variacion)"></i>
                                                <span class="an-kpi-var-valor">{{ formatearVariacion(incidencias.comparativas[clave].ratio.variacion) }}</span>
                                                <span class="an-kpi-var-etiqueta">{{ $t("anRatioFrenteA") }} {{ etiquetaCorta('A') }}</span>
                                            </div>
                                        </div>
                                        <div v-if="incidencias.resumen[clave].tipoPredominante" class="an-kpi-sub">{{ $t("anTipoPredominante") }}: <strong>{{ $t(incidencias.resumen[clave].tipoPredominante) }}</strong></div>
                                    </div>
                                </div>

                                <div class="an-graficas">
                                    <div class="an-grafica an-grafica-ancha">
                                        <div class="an-grafica-cabecera"><h5>{{ $t("anEvolucionIncidencias") }} <small class="text-muted">{{ $t("anUltimos13Meses") }} · {{ $t("anBarrasTotalLineaRatio") }}</small></h5></div>
                                        <div class="an-canvas"><canvas ref="canvasIncEvolucion"></canvas></div>
                                    </div>
                                    <div class="an-grafica an-grafica-ancha">
                                        <div class="an-grafica-cabecera">
                                            <h5>{{ $t("anIncidenciasPorDia") }} <small class="text-muted">{{ $t("anPulsaDiaParaCierreZ") }}</small></h5>
                                            <div class="an-grafica-opciones">
                                                <label class="an-check"><input type="checkbox" v-model="alinearSemana" @change="cargarIncidencias()" /> {{ $t("anAlinearPorDiaSemana") }}</label>
                                            </div>
                                        </div>
                                        <div class="an-canvas"><canvas ref="canvasIncDiario"></canvas></div>
                                    </div>
                                    <div class="an-grafica">
                                        <div class="an-grafica-cabecera"><h5>{{ $t("anIncidenciasPorTipo") }}</h5></div>
                                        <div class="an-canvas"><canvas ref="canvasIncTipos"></canvas></div>
                                    </div>
                                    <div class="an-grafica">
                                        <div class="an-grafica-cabecera"><h5>{{ $t("anIncidenciasPorOperario") }} <small class="text-muted">{{ etiquetaCorta('A') }} · top 10</small></h5></div>
                                        <div class="an-canvas"><canvas ref="canvasIncOperarios"></canvas></div>
                                    </div>
                                    <div class="an-grafica an-grafica-ancha">
                                        <div class="an-grafica-cabecera"><h5>{{ $t("anIncidenciasPorProducto") }} <small class="text-muted">{{ etiquetaCorta('A') }} · top 10 · {{ $t("anAQueSeDeben") }}</small></h5></div>
                                        <div class="an-canvas"><canvas ref="canvasIncProductos"></canvas></div>
                                    </div>
                                </div>
                                <div v-if="incidencias.notas.length" class="an-notas-grafica">
                                    <span v-for="n in incidencias.notas" :key="'in-' + n" class="an-badge">{{ textoNota(n) }}</span>
                                </div>

                                <h5 class="an-titulo-tabla">{{ $t("anPorNegocioYTpv") }}</h5>
                                <div class="an-scroll">
                                    <table class="table table-bordered table-hover an-tabla">
                                        <thead>
                                            <tr>
                                                <th>{{ $t("negocio") }}</th>
                                                <th>{{ $t("tpv") }}</th>
                                                <th v-for="col in columnasPeriodoDobles" :key="'it-' + col.tipo + col.clave" class="text-right">
                                                    {{ col.tipo === 'a' ? $t("incidencias") : $t("anPor100Docs") }} <small>{{ etiquetaCorta(col.clave) }}</small>
                                                </th>
                                                <th v-if="clavesComparadas.length" class="text-right">{{ $t("anVariacionRatio") }}</th>
                                                <th>{{ $t("anTipoPredominante") }} <small>{{ etiquetaCorta('A') }}</small></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="fila in incidencias.tabla" :key="'if-' + fila.idTpv" :class="{ 'an-fila-sin-datos': fila.sinDatos }">
                                                <td>{{ fila.nombreNegocio }}</td>
                                                <td>{{ fila.nombreTpv }}</td>
                                                <td v-for="col in columnasPeriodoDobles" :key="'it-' + fila.idTpv + col.tipo + col.clave" class="text-right">
                                                    {{ col.tipo === 'a' ? fila.periodos[col.clave].incidencias : formatearDecimal(fila.periodos[col.clave].ratio) }}
                                                </td>
                                                <td v-if="clavesComparadas.length" class="text-right" :class="claseVariacion(kpiIncidencias, fila.variacion ? fila.variacion.ratio.variacion : null)">
                                                    {{ fila.variacion ? formatearVariacion(fila.variacion.ratio.variacion) : '' }}
                                                </td>
                                                <td>{{ fila.periodos.A.tipoPredominante ? $t(fila.periodos.A.tipoPredominante) : '–' }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </template>
                        </div>

                        <!-- Pestaña Rentabilidad -->
                        <div v-if="pestana === 'rentabilidad'" class="an-pestana-cuerpo">
                            <div v-if="cargandoRentabilidad" class="an-cargando"><i class="fa fa-spinner fa-spin"></i> {{ $t("cargando") }}</div>
                            <template v-else-if="rentabilidad">
                                <!-- Cobertura y avisos -->
                                <div class="an-nota" :class="rentabilidad.cobertura.itemsConCoste === 0 ? 'an-nota-error' : 'an-nota-aviso'">
                                    <i class="fas fa-info-circle"></i>
                                    {{ $t("anCoberturaCoste", { conCoste: rentabilidad.cobertura.itemsConCoste, total: rentabilidad.cobertura.items, pct: formatearDecimal(rentabilidad.cobertura.porcentajeVentasConCoste) }) }}
                                    {{ $t("anCosteActualNota") }}
                                    <template v-if="rentabilidad.corteNoAplicado"> {{ $t("anRentabilidadMesesCompletos") }}</template>
                                </div>

                                <div class="an-controles">
                                    <div class="btn-group an-modo">
                                        <button type="button" class="btn btn-sm" :class="agrupar === 'tarifa' ? 'btn-primary btn-fill' : 'btn-default'" @click="cambiarAgrupacion('tarifa')">{{ $t("anPorProductoYTarifa") }}</button>
                                        <button type="button" class="btn btn-sm" :class="agrupar === 'producto' ? 'btn-primary btn-fill' : 'btn-default'" @click="cambiarAgrupacion('producto')">{{ $t("anPorProducto") }}</button>
                                    </div>
                                    <select class="form-control an-control" v-model="filtroCategoria">
                                        <option value="">{{ $t("anTodasLasCategorias") }}</option>
                                        <option v-for="c in categoriasRentabilidad" :key="'cat-' + c" :value="c">{{ c }}</option>
                                    </select>
                                    <select class="form-control an-control" v-model="filtroCuadrante">
                                        <option value="">{{ $t("anTodosLosCuadrantes") }}</option>
                                        <option v-for="q in cuadrantes" :key="'q-' + q" :value="q">{{ $t(etiquetaCuadrante(q)) }}</option>
                                        <option value="sinCoste">{{ $t("anSinCoste") }}</option>
                                    </select>
                                    <input type="text" class="form-control an-control" v-model="buscarItem" :placeholder="$t('buscarProducto')" />
                                </div>

                                <!-- Resumen por cuadrante -->
                                <div class="an-kpis an-kpis-pestana">
                                    <div v-for="q in cuadrantes" :key="'kq-' + q" class="card an-kpi an-kpi-cuadrante" :style="{ borderTopColor: colorCuadrante(q) }">
                                        <div class="an-kpi-titulo">{{ $t(etiquetaCuadrante(q)) }} <i class="fas fa-info-circle an-ayuda" v-tooltip.top-center="$i18n.t(etiquetaCuadrante(q) + 'Ayuda')"></i></div>
                                        <div class="an-kpi-valor">{{ rentabilidad.resumen.cuadrantes[q].items }} <small>{{ $t("anItems") }}</small></div>
                                        <div class="an-kpi-sub">{{ $t("anMargenContribucion") }}: <strong>{{ formatear(rentabilidad.resumen.cuadrantes[q].mcTotal, 'importe') }}</strong>
                                            <span v-if="rentabilidad.resumen.mcTotal" class="an-pct">({{ formatearPct(rentabilidad.resumen.cuadrantes[q].mcTotal / rentabilidad.resumen.mcTotal * 100) }})</span></div>
                                        <div v-if="rentabilidad.comparado" class="an-kpi-sub an-kpi-var-etiqueta">{{ etiquetaCorta('B') }}: {{ rentabilidad.comparado.resumen.cuadrantes[q].items }} {{ $t("anItems") }} · {{ formatear(rentabilidad.comparado.resumen.cuadrantes[q].mcTotal, 'importe') }}</div>
                                    </div>
                                    <div class="card an-kpi">
                                        <div class="an-kpi-titulo">{{ $t("anUmbrales") }}</div>
                                        <div class="an-kpi-sub">{{ $t("anIndicePopularidadMedio") }}: <strong>{{ formatearDecimal(rentabilidad.umbrales.popularidad) }} %</strong></div>
                                        <div class="an-kpi-sub">{{ $t("anRentabilidadMedia") }}: <strong>{{ formatear(rentabilidad.umbrales.mcUnitario, 'importe') }}</strong></div>
                                        <div class="an-kpi-sub">{{ $t("anMediaCoste") }}: <strong>{{ formatearDecimal(rentabilidad.resumen.costeMedioPct) }} %</strong></div>
                                        <div class="an-kpi-sub">{{ $t("anMargenContribucion") }}: <strong>{{ formatear(rentabilidad.resumen.mcTotal, 'importe') }}</strong></div>
                                    </div>
                                </div>

                                <div class="an-graficas">
                                    <div class="an-grafica an-grafica-ancha">
                                        <div class="an-grafica-cabecera">
                                            <h5>{{ $t("anMatrizPopularidadMargen") }} <small class="text-muted">{{ $t("anMatrizExplicacion") }}</small></h5>
                                        </div>
                                        <div class="an-canvas an-canvas-alta"><canvas ref="canvasMatriz"></canvas></div>
                                    </div>
                                    <div class="an-grafica">
                                        <div class="an-grafica-cabecera"><h5>{{ $t("anMargenPorCuadrante") }}</h5></div>
                                        <div class="an-canvas"><canvas ref="canvasCuadrantes"></canvas></div>
                                    </div>
                                    <div class="an-grafica">
                                        <div class="an-grafica-cabecera"><h5>{{ $t("anTopMargen") }} <small class="text-muted">top 12</small></h5></div>
                                        <div class="an-canvas"><canvas ref="canvasTopMargen"></canvas></div>
                                    </div>
                                </div>

                                <!-- Cambios de cuadrante -->
                                <div v-if="rentabilidad.cambiosCuadrante.length" class="an-cambios">
                                    <h5 class="an-titulo-tabla">{{ $t("anCambiosCuadrante") }} <small class="text-muted">{{ etiquetaCorta('B') }} → {{ etiquetaCorta('A') }}</small></h5>
                                    <div class="an-chips">
                                        <span v-for="c in rentabilidad.cambiosCuadrante.slice(0, 20)" :key="'cc-' + c.clave" class="an-chip-cambio">
                                            <strong>{{ c.nombre }}</strong><template v-if="c.nombreTarifa"> · {{ c.nombreTarifa }}</template>:
                                            <span :style="{ color: colorCuadrante(c.de) }">{{ $t(etiquetaCuadrante(c.de)) }}</span> → <span :style="{ color: colorCuadrante(c.a) }">{{ $t(etiquetaCuadrante(c.a)) }}</span>
                                            <small>({{ formatear(c.mcTotalAnterior, 'importe') }} → {{ formatear(c.mcTotal, 'importe') }})</small>
                                        </span>
                                    </div>
                                </div>

                                <!-- Tabla -->
                                <h5 class="an-titulo-tabla">{{ $t("anTablaIngenieriaMenu") }} <small class="text-muted">{{ itemsVista.length }} {{ $t("anItems") }}</small></h5>
                                <div class="an-scroll">
                                    <table class="table table-bordered table-hover an-tabla an-tabla-rent">
                                        <thead>
                                            <tr>
                                                <th class="an-ordenable" @click="ordenarItems('nombre')">{{ $t("producto") }} {{ flechaOrden('nombre') }}</th>
                                                <th class="an-ordenable" @click="ordenarItems('categoria')">{{ $t("categoria") }} {{ flechaOrden('categoria') }}</th>
                                                <th class="text-right an-ordenable" @click="ordenarItems('uds')">{{ $t("anNumeroVentas") }} {{ flechaOrden('uds') }}</th>
                                                <th v-if="rentabilidad.comparado" class="text-right">{{ $t("anVariacion") }} <small>{{ $t("unidades") }}</small></th>
                                                <th class="text-right an-ordenable" @click="ordenarItems('costeUnitario')">{{ $t("anCosteProducto") }} {{ flechaOrden('costeUnitario') }}</th>
                                                <th class="text-right an-ordenable" @click="ordenarItems('pvpMedioSinIva')">{{ $t("anPrecioVentaSinIva") }} {{ flechaOrden('pvpMedioSinIva') }}</th>
                                                <th class="text-right an-ordenable" @click="ordenarItems('popularidad')">{{ $t("anIndicePopularidad") }} {{ flechaOrden('popularidad') }}</th>
                                                <th class="text-right an-ordenable" @click="ordenarItems('costePct')">{{ $t("anCosteProductoPct") }} {{ flechaOrden('costePct') }}</th>
                                                <th class="text-right an-ordenable" @click="ordenarItems('mcUnitario')">{{ $t("anMargenContribucion") }} {{ flechaOrden('mcUnitario') }}</th>
                                                <th class="text-right an-ordenable" @click="ordenarItems('costeTotal')">{{ $t("anTotalCoste") }} {{ flechaOrden('costeTotal') }}</th>
                                                <th class="text-right an-ordenable" @click="ordenarItems('importeSinIva')">{{ $t("anTotalVentas") }} {{ flechaOrden('importeSinIva') }}</th>
                                                <th class="text-right an-ordenable" @click="ordenarItems('mcTotal')">{{ $t("anMargenContribucionTotal") }} {{ flechaOrden('mcTotal') }}</th>
                                                <th v-if="rentabilidad.comparado" class="text-right">{{ $t("anVariacion") }} <small>{{ $t("anMargenContribucionTotal") }}</small></th>
                                                <th>{{ $t("anClasifRentabilidad") }}</th>
                                                <th>{{ $t("anClasifPopularidad") }}</th>
                                                <th class="an-ordenable" @click="ordenarItems('cuadrante')">{{ $t("anClasifFinal") }} {{ flechaOrden('cuadrante') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="it in itemsVista" :key="'it-' + it.clave" :class="{ 'an-fila-sin-coste': !it.tieneCoste }">
                                                <td>
                                                    {{ it.nombre }}
                                                    <span v-if="it.nombreTarifa" class="an-badge an-badge-tarifa">{{ it.nombreTarifa }}</span>
                                                    <i v-if="!it.tarifaIdentificada" class="fas fa-question-circle an-ayuda" v-tooltip.top-center="$i18n.t('anTarifaNoIdentificada')"></i>
                                                    <span v-if="it.esMenu" class="an-badge">{{ $t("menu") }}</span>
                                                </td>
                                                <td>{{ it.categoria }}</td>
                                                <td class="text-right">{{ formatearUds(it.uds) }}</td>
                                                <td v-if="rentabilidad.comparado" class="text-right" :class="claseVariacion(kpiVentas, it.anterior ? it.anterior.variacionUds : null)">{{ it.anterior ? formatearVariacion(it.anterior.variacionUds) : $t("anNuevo") }}</td>
                                                <td class="text-right">{{ it.tieneCoste ? formatear(it.costeUnitario, 'importe') : '–' }}</td>
                                                <td class="text-right">{{ formatear(it.pvpMedioSinIva, 'importe') }}</td>
                                                <td class="text-right">{{ it.popularidad === null ? '–' : formatearDecimal(it.popularidad) + ' %' }}</td>
                                                <td class="text-right">{{ it.costePct === null ? '–' : formatearDecimal(it.costePct) + ' %' }}</td>
                                                <td class="text-right">{{ formatear(it.mcUnitario, 'importe') }}</td>
                                                <td class="text-right">{{ formatear(it.costeTotal, 'importe') }}</td>
                                                <td class="text-right">{{ formatear(it.importeSinIva, 'importe') }}</td>
                                                <td class="text-right"><strong>{{ formatear(it.mcTotal, 'importe') }}</strong></td>
                                                <td v-if="rentabilidad.comparado" class="text-right" :class="claseVariacion(kpiVentas, it.anterior ? it.anterior.variacionMc : null)">{{ it.anterior ? formatearVariacion(it.anterior.variacionMc) : '' }}</td>
                                                <td>{{ it.rentabilidadAlta === null ? '–' : (it.rentabilidadAlta ? $t("anAlta") : $t("anBaja")) }}</td>
                                                <td>{{ it.popularidadAlta === null ? '–' : (it.popularidadAlta ? $t("anAlta") : $t("anBaja")) }}</td>
                                                <td>
                                                    <span v-if="it.cuadrante" class="an-badge-cuadrante" :style="{ background: colorCuadrante(it.cuadrante) }">{{ $t(etiquetaCuadrante(it.cuadrante)) }}</span>
                                                    <span v-else class="an-pct">{{ it.uds <= 0 ? $t("anSinUnidades") : $t("anSinCoste") }}</span>
                                                </td>
                                            </tr>
                                            <tr v-if="!itemsVista.length"><td colspan="17" class="text-muted">{{ $t("sinDatos") }}</td></tr>
                                        </tbody>
                                    </table>
                                </div>

                                <!-- Omnes -->
                                <h5 class="an-titulo-tabla">{{ $t("anPrincipiosOmnes") }}
                                    <select class="form-control an-control an-control-inline" v-model="gamaOmnes">
                                        <option value="total">{{ $t("anTodaLaCarta") }}</option>
                                        <option v-for="g in rentabilidad.omnes.categorias" :key="'g-' + g.gama" :value="g.gama">{{ g.gama }} ({{ g.items }})</option>
                                    </select>
                                </h5>
                                <div v-if="omnesGama" class="an-omnes">
                                    <div class="an-grafica">
                                        <div class="an-grafica-cabecera"><h5>1. {{ $t("anDispersionPrecios") }}</h5></div>
                                        <div class="an-omnes-valor" :class="claseOmnesDispersion(omnesGama)">
                                            {{ omnesGama.dispersion.coeficiente === null ? '–' : formatearDecimal(omnesGama.dispersion.coeficiente) }}
                                        </div>
                                        <p class="an-omnes-texto">{{ $t("anDispersionTexto", { max: formatear(omnesGama.dispersion.max, 'importe'), min: formatear(omnesGama.dispersion.min, 'importe') }) }}</p>
                                        <p class="an-omnes-texto an-pct">{{ omnesGama.dispersion.aplica ? $t("anDispersionIdeal") : $t("anDispersionNoAplica") }}</p>
                                    </div>
                                    <div class="an-grafica">
                                        <div class="an-grafica-cabecera"><h5>2. {{ $t("anAmplitudGama") }}</h5></div>
                                        <div class="an-canvas an-canvas-baja"><canvas ref="canvasOmnes"></canvas></div>
                                        <p class="an-omnes-texto an-pct">{{ $t("anAmplitudTexto", { bajo: formatear(omnesGama.amplitud.corteBajo, 'importe'), alto: formatear(omnesGama.amplitud.corteAlto, 'importe') }) }}</p>
                                    </div>
                                    <div class="an-grafica">
                                        <div class="an-grafica-cabecera"><h5>3. {{ $t("anRelacionCalidadPrecio") }}</h5></div>
                                        <div class="an-omnes-valor" :class="claseOmnesRatio(ratioSimulado)">{{ ratioSimulado === null ? '–' : formatearDecimal(ratioSimulado) }}</div>
                                        <p class="an-omnes-texto">
                                            {{ $t("anPrecioMedioSolicitado") }}: <strong>{{ formatear(omnesGama.calidadPrecio.precioMedioSolicitado, 'importe') }}</strong><br />
                                            {{ $t("anPrecioMedioOfertado") }}: <strong>{{ formatear(omnesGama.calidadPrecio.precioMedioOfertado * (1 + ajusteOmnes / 100), 'importe') }}</strong>
                                        </p>
                                        <p class="an-omnes-texto an-omnes-recomendacion" :class="claseOmnesRatio(ratioSimulado)">{{ textoRecomendacion(ratioSimulado) }}</p>
                                        <div class="an-simulador">
                                            <label>{{ $t("anSimularCambioPrecios") }}: <strong>{{ ajusteOmnes > 0 ? '+' : '' }}{{ ajusteOmnes }} %</strong></label>
                                            <input type="range" min="-30" max="30" step="1" v-model.number="ajusteOmnes" />
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { mapState, mapMutations } from "vuex";
import moment from "moment";
import swal from "sweetalert2";
import Chart from "chart.js";

/* Colores fijos por periodo: A el azul Numier, B gris, C ámbar. */
const COLORES = {
    A: { linea: "#1E22AA", relleno: "rgba(30, 34, 170, 0.18)" },
    B: { linea: "#7a82a8", relleno: "rgba(122, 130, 168, 0.18)" },
    C: { linea: "#e0a12a", relleno: "rgba(224, 161, 42, 0.18)" },
};

export default {
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
    },

    data() {
        const hoy = moment();
        return {
            // Ámbito
            listCompanies: [],
            idCompany: null,
            listBusinesses: [],
            idsBusiness: [],
            idSector: null,

            // Periodos
            modo: "mes",
            mesActual: hoy.format("YYYY-MM"),
            mesA: hoy.format("YYYY-MM"),
            compararMes: "ambos",
            rangoA: { desde: hoy.clone().subtract(1, "month").format("YYYY-MM"), hasta: hoy.format("YYYY-MM") },
            rangoB: { desde: "", hasta: "" },
            anioA: hoy.year(),
            compararAnio: "anterior",

            // Estado
            cargando: false,
            consultado: false,
            recalculando: false,
            // Límite de recálculo que devuelve la API: instante (ms) hasta el que no se puede recalcular
            recalculoHasta: 0,
            recalculoMotivo: "",
            ahora: Date.now(),
            relojEspera: null,
            resumen: null,
            kpis: {},
            comparativas: {},
            periodos: {},
            cacheEstado: null,

            pestana: "ventas",

            // Evolución
            evolucion: [],
            cargandoEvolucion: false,
            metricaEvolucion: "ventas",

            // Ventas
            ventas: null,
            cargandoVentas: false,
            alinearSemana: false,

            // Formas de pago
            formasPago: null,
            cargandoFormasPago: false,
            fpEvolucionPorcentaje: false,

            // Incidencias
            incidencias: null,
            cargandoIncidencias: false,
            kpiIncidencias: { clave: "incidencias", tipo: "entero", inverso: true },

            // Rentabilidad
            rentabilidad: null,
            cargandoRentabilidad: false,
            agrupar: "tarifa",
            filtroCategoria: "",
            filtroCuadrante: "",
            buscarItem: "",
            ordenItems: { campo: "mcTotal", asc: false },
            cuadrantes: ["lider", "popular", "rentable", "revisar"],
            gamaOmnes: "total",
            ajusteOmnes: 0,

            graficas: {},
            sidebarMinimizadoAqui: false,
            exportando: "",
            consultaDesdeQuery: false,

            kpiCards: [
                { clave: "ventas", etiqueta: "ventas", tipo: "importe", nota: true },
                { clave: "documentos", etiqueta: "numDocumentos", tipo: "entero", nota: true },
                { clave: "ticketMedio", etiqueta: "ticketMedio", tipo: "importe" },
                { clave: "mediaDiaria", etiqueta: "anMediaDiaria", tipo: "importe" },
                { clave: "comensales", etiqueta: "nDeComensales", tipo: "entero", nota: true },
                { clave: "incidencias", etiqueta: "incidencias", tipo: "entero", inverso: true, nota: true },
            ],
            kpiVentas: { clave: "ventas", tipo: "importe" },
        };
    },

    created() {
        // Desde Cierre de caja Z se llega con ?mes=AAAA-MM (&idCompany, &idsBusiness o &idSector).
        this.getCompanies().then(() => this.aplicarQuery());
        if (this.modoSectores) this.initSectores();
        window.addEventListener("resize", this.redibujar);
    },

    mounted() {
        if (this.$sidebar && !this.$sidebar.isMinimized) {
            this.$sidebar.toggleMinimize();
            this.sidebarMinimizadoAqui = true;
        }
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.redibujar);
        this.pararRelojEspera();
        this.destruirGraficas();
        if (this.sidebarMinimizadoAqui && this.$sidebar && this.$sidebar.isMinimized) {
            this.$sidebar.toggleMinimize();
        }
    },

    watch: {
        pestana(nueva) {
            if (!this.tieneDatos) return;
            if (nueva === "ventas" && this.ventas) this.$nextTick(() => { this.pintarEvolucion(); this.pintarDiario(); this.pintarSemana(); this.pintarHoras(); });
            if (nueva === "formasPago") { if (this.formasPago) this.$nextTick(this.pintarFormasPago); else this.cargarFormasPago(); }
            if (nueva === "incidencias") { if (this.incidencias) this.$nextTick(this.pintarIncidencias); else this.cargarIncidencias(); }
            if (nueva === "rentabilidad") { if (this.rentabilidad) this.$nextTick(this.pintarRentabilidad); else this.cargarRentabilidad(); }
        },

        gamaOmnes() {
            this.ajusteOmnes = 0;
            this.$nextTick(this.pintarOmnes);
        },

        filtroCategoria() { this.$nextTick(this.pintarMatriz); },
        filtroCuadrante() { this.$nextTick(this.pintarMatriz); },
        buscarItem() { this.$nextTick(this.pintarMatriz); },

        sectoresEmpresa(lista) {
            if (!this.modoSectores) return;
            if (!lista.some(sc => sc.id === this.idSector)) {
                this.idSector = lista.length ? lista[0].id : null;
            }
        },
    },

    computed: {
        /* Segundos que faltan para poder recalcular (0 = disponible). */
        recalculoEspera() {
            return Math.max(0, Math.ceil((this.recalculoHasta - this.ahora) / 1000));
        },
        textoEsperaRecalculo() {
            const s = this.recalculoEspera;
            if (s < 60) return "< 1 min";
            const m = Math.ceil(s / 60);
            return m >= 60 ? Math.floor(m / 60) + " h " + (m % 60) + " min" : m + " min";
        },
        ...mapState(["listaSectores", "sectores"]),

        modoSectores() {
            return !!this.sectores && this.$cookies && this.$cookies.isKey("sectores");
        },

        sectoresEmpresa() {
            const lista = this.listaSectores || [];
            if (!this.idCompany) return lista;
            const propios = lista.filter(sc => sc.idCompany !== undefined && parseInt(sc.idCompany, 10) === parseInt(this.idCompany, 10));
            return propios.length ? propios : lista;
        },

        aniosDisponibles() {
            const actual = moment().year();
            const lista = [];
            for (let a = actual; a >= actual - 5; a--) lista.push(a);
            return lista;
        },

        tieneDatos() {
            return !!this.kpis.A && (this.kpis.A.documentos > 0 || this.kpis.A.sesiones > 0);
        },

        clavesPeriodos() {
            return Object.keys(this.periodos);
        },

        clavesComparadas() {
            return this.clavesPeriodos.filter(c => c !== "A");
        },

        /* Dos columnas por periodo (importe y %, incidencias y ratio) en una sola lista para
           iterar con un único v-for: en Vue 2 <template v-for> no admite key y el editor lo marca. */
        columnasPeriodoDobles() {
            const columnas = [];
            this.clavesPeriodos.forEach(clave => {
                columnas.push({ clave: clave, tipo: "a" });
                columnas.push({ clave: clave, tipo: "b" });
            });
            return columnas;
        },

        periodosReordenados() {
            return !!(this.periodos.A && this.periodos.A.reordenado);
        },

        /* "Variación: ene 2025 → ene 2026 (cuánto ha cambiado lo reciente respecto a lo anterior)" */
        textoDireccionVariacion() {
            if (!this.clavesComparadas.length) return "";
            return this.$t("anVariacionDireccion", { antiguo: this.etiquetaCorta(this.clavesComparadas[0]), reciente: this.etiquetaCorta("A") });
        },

        filasTabla() {
            return this.ventas ? this.ventas.tabla : [];
        },

        categoriasRentabilidad() {
            if (!this.rentabilidad) return [];
            const vistas = {};
            this.rentabilidad.items.forEach(it => { if (it.categoria) vistas[it.categoria] = true; });
            return Object.keys(vistas).sort();
        },

        itemsVista() {
            if (!this.rentabilidad) return [];
            const texto = this.buscarItem.trim().toLowerCase();
            const lista = this.rentabilidad.items.filter(it => {
                if (this.filtroCategoria && it.categoria !== this.filtroCategoria) return false;
                if (this.filtroCuadrante === "sinCoste" && it.cuadrante) return false;
                if (this.filtroCuadrante && this.filtroCuadrante !== "sinCoste" && it.cuadrante !== this.filtroCuadrante) return false;
                if (texto && (it.nombre + " " + (it.nombreTarifa || "")).toLowerCase().indexOf(texto) === -1) return false;
                return true;
            });
            const campo = this.ordenItems.campo;
            const asc = this.ordenItems.asc ? 1 : -1;
            return lista.sort((a, b) => {
                const va = a[campo], vb = b[campo];
                if (va === null || va === undefined) return 1;
                if (vb === null || vb === undefined) return -1;
                if (typeof va === "string") return va.localeCompare(vb) * asc;
                return (va - vb) * asc;
            });
        },

        omnesGama() {
            if (!this.rentabilidad) return null;
            if (this.gamaOmnes === "total") return this.rentabilidad.omnes.total.items ? this.rentabilidad.omnes.total : null;
            return this.rentabilidad.omnes.categorias.find(g => g.gama === this.gamaOmnes) || null;
        },

        ratioSimulado() {
            const g = this.omnesGama;
            if (!g || g.calidadPrecio.precioMedioSolicitado === null) return null;
            const ofertado = g.calidadPrecio.precioMedioOfertado * (1 + this.ajusteOmnes / 100);
            return ofertado > 0 ? g.calidadPrecio.precioMedioSolicitado / ofertado : null;
        },

        /* Periodos que se enviarán a la API según el modo. Devuelve null si el
           usuario no ha terminado de rellenarlos. */
        periodosSolicitados() {
            if (this.modo === "mes") {
                if (!/^\d{4}-\d{2}$/.test(this.mesA)) return null;
                const a = moment(this.mesA + "-01");
                const p = { desde: this.mesA, hasta: this.mesA };
                if (this.compararMes === "anterior" || this.compararMes === "ambos") {
                    const b = a.clone().subtract(1, "month").format("YYYY-MM");
                    p.desdeB = b; p.hastaB = b;
                }
                if (this.compararMes === "anioAnterior" || this.compararMes === "ambos") {
                    const c = a.clone().subtract(1, "year").format("YYYY-MM");
                    if (this.compararMes === "ambos") { p.desdeC = c; p.hastaC = c; } else { p.desdeB = c; p.hastaB = c; }
                }
                return p;
            }

            if (this.modo === "rango") {
                if (!/^\d{4}-\d{2}$/.test(this.rangoA.desde) || !/^\d{4}-\d{2}$/.test(this.rangoA.hasta)) return null;
                const p = { desde: this.rangoA.desde, hasta: this.rangoA.hasta };
                if (this.rangoB.desde || this.rangoB.hasta) {
                    p.desdeB = this.rangoB.desde || this.rangoB.hasta;
                    p.hastaB = this.rangoB.hasta || this.rangoB.desde;
                }
                return p;
            }

            // Año: hasta hoy si es el año en curso; comparado con el anterior hasta la misma fecha.
            const hoy = moment();
            const enCurso = this.anioA === hoy.year();
            const finA = enCurso ? hoy : moment({ year: this.anioA, month: 11, day: 31 });
            const p = { desde: this.anioA + "-01", hasta: finA.format("YYYY-MM") };
            if (enCurso) p.corte = hoy.format("YYYY-MM-DD");
            if (this.compararAnio === "anterior") {
                const finB = finA.clone().subtract(1, "year");
                p.desdeB = (this.anioA - 1) + "-01";
                p.hastaB = finB.format("YYYY-MM");
                // Un 29 de febrero sin pareja cae al 28: moment ya lo hace al restar el año.
                if (enCurso) p.corteB = finB.format("YYYY-MM-DD");
            }
            return p;
        },

        errorPeriodo() {
            const p = this.periodosSolicitados;
            if (!p) return this.$t("anCompletaPeriodo");
            const meses = (d, h) => moment(h + "-01").diff(moment(d + "-01"), "months") + 1;
            if (meses(p.desde, p.hasta) < 1) return this.$t("anPeriodoInvertido");
            if (meses(p.desde, p.hasta) > 12) return this.$t("anMaximo12Meses");
            if (p.desdeB && meses(p.desdeB, p.hastaB) < 1) return this.$t("anPeriodoInvertido");
            if (p.desdeB && meses(p.desdeB, p.hastaB) > 12) return this.$t("anMaximo12Meses");
            return "";
        },

        puedeConsultar() {
            return !!this.idCompany && (!this.modoSectores || !!this.idSector) && !this.errorPeriodo;
        },

        resumenPeriodos() {
            const p = this.periodosSolicitados;
            if (!p) return "";
            const partes = [this.$t("anPeriodoA") + ": " + this.textoPeriodo(p.desde, p.hasta, p.corte)];
            if (p.desdeB) partes.push(this.$t("anPeriodoB") + ": " + this.textoPeriodo(p.desdeB, p.hastaB, p.corteB));
            if (p.desdeC) partes.push(this.$t("anPeriodoC") + ": " + this.textoPeriodo(p.desdeC, p.hastaC, p.corteC));
            return partes.join(" · ");
        },

        pestanaCargada() {
            if (!this.tieneDatos) return false;
            return { ventas: !!this.ventas, formasPago: !!this.formasPago, incidencias: !!this.incidencias, rentabilidad: !!this.rentabilidad }[this.pestana] || false;
        },

        cacheInfo() {
            const c = this.cacheEstado;
            if (!c) return "";
            if (c.calculados > 0) return this.$t("anCalculadosAhora", { n: c.calculados, total: c.tpvMes });
            if (c.calculadoMasAntiguo) return this.$t("anDatosDeCache", { fecha: moment.unix(c.calculadoMasAntiguo).format("DD/MM HH:mm") });
            return "";
        },
    },

    methods: {
        ...mapMutations(["changeListaSectores"]),

        /* ---------- Selectores ---------- */

        getCompanies() {
            const config = { params: { jwt: this.$store.getters.jwt }, headers: { Authorization: "Bearer " + this.$store.getters.jwt } };
            return this.axios.get(this.$store.getters.apiUrl + "general/getCompaniesByUser", config)
                .then(response => {
                    this.listCompanies = response.data.result || [];
                    if (this.listCompanies.length && !this.idCompany) this.idCompany = this.listCompanies[0].id;
                    return this.getBusinesses();
                })
                .catch(error => console.error(error));
        },

        getBusinesses() {
            if (!this.idCompany) return Promise.resolve();
            const config = { params: { idCompany: this.idCompany, jwt: this.$store.getters.jwt }, headers: { Authorization: "Bearer " + this.$store.getters.jwt } };
            return this.axios.get(this.$store.getters.apiUrl + "businesses/getBusinessesByIdCompany", config)
                .then(response => { this.listBusinesses = Array.isArray(response.data) ? response.data : (response.data.result || []); })
                .catch(error => console.error(error));
        },

        onCompanyChange() {
            this.idsBusiness = [];
            this.getBusinesses();
        },

        initSectores() {
            if (this.listaSectores && this.listaSectores.length) {
                this.idSector = this.sectoresEmpresa.length ? this.sectoresEmpresa[0].id : this.listaSectores[0].id;
                return;
            }
            const config = { params: { jwt: this.$store.getters.jwt }, headers: { Authorization: "Bearer " + this.$store.getters.jwt } };
            this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesSectors", config)
                .then(response => {
                    if (!response.data.response) return;
                    const sectores = (response.data.result.sectores || []).map(sc => Object.assign({}, sc, { id: parseInt(sc.id, 10), idBusinessMaster: parseInt(sc.idBusinessMaster, 10) }));
                    this.changeListaSectores(sectores);
                    if (sectores.length) this.idSector = this.sectoresEmpresa.length ? this.sectoresEmpresa[0].id : sectores[0].id;
                })
                .catch(error => console.error(error));
        },

        /* Parámetros de entrada desde Cierre de caja Z: consulta el mes indicado. */
        aplicarQuery() {
            const q = (this.$route && this.$route.query) ? this.$route.query : {};
            if (!q.mes || !/^\d{4}-\d{2}$/.test(String(q.mes))) return;

            // Ids tomados de las propias listas para que el tipo coincida con el value de
            // las opciones del el-select (si no, el selector muestra el id en crudo).
            let cadena = Promise.resolve();
            const empresa = q.idCompany ? this.listCompanies.find(c => String(c.id) === String(q.idCompany)) : null;
            if (empresa) {
                this.idCompany = empresa.id;
                cadena = this.getBusinesses() || Promise.resolve();
            }
            cadena.then(() => {
                if (q.idsBusiness) {
                    const pedidos = String(q.idsBusiness).split(",");
                    this.idsBusiness = this.listBusinesses.filter(b => pedidos.includes(String(b.id))).map(b => b.id);
                }
                if (q.idSector && this.modoSectores) this.idSector = parseInt(q.idSector, 10);
                this.modo = "mes";
                this.mesA = String(q.mes);
                this.compararMes = "ambos";
                this.$nextTick(() => this.consultar(false));
            });
        },

        /* ---------- Consulta ---------- */

        baseParams(forzar) {
            const params = Object.assign({ jwt: this.$store.getters.jwt, idCompany: this.idCompany }, this.periodosSolicitados);
            if (this.modoSectores) params.idSector = this.idSector; else params.idsBusiness = this.idsBusiness.join(",");
            if (forzar) params.forzar = 1;
            return params;
        },

        config(params) {
            return { params: params, headers: { Authorization: "Bearer " + this.$store.getters.jwt } };
        },

        consultar(forzar) {
            if (!this.puedeConsultar) return;
            this.cargando = true;
            this.consultado = false;
            this.ventas = null;
            this.evolucion = [];
            this.formasPago = null;
            this.incidencias = null;
            this.rentabilidad = null;
            this.destruirGraficas();

            this.axios.get(this.$store.getters.apiUrl + "analisisnegocio/getResumen", this.config(this.baseParams(forzar)))
                .then(response => {
                    const datos = response.data || {};
                    if (!datos.response) {
                        this.kpis = {}; this.periodos = {}; this.comparativas = {};
                        swal({ title: this.$t("atencion"), text: datos.message || this.$t("errorDesconocido"), type: "warning" });
                        return;
                    }
                    this.kpis = datos.result.kpis || {};
                    this.comparativas = datos.result.comparativas || {};
                    this.periodos = datos.result.periodos || {};
                    this.cacheEstado = datos.result.cache || null;
                    this.aplicarEstadoRecalculo(datos.result.recalculo);
                    // Primero se pinta la pantalla (KPIs y huecos de las gráficas) y
                    // después se piden las series, que ya encuentran sus canvas.
                    this.cargando = false;
                    this.consultado = true;
                    this.$nextTick(() => {
                        if (this.pestana === "ventas") {
                            this.cargarVentas();
                            this.cargarEvolucion();
                        } else if (this.pestana === "formasPago") {
                            this.cargarFormasPago();
                        } else if (this.pestana === "incidencias") {
                            this.cargarIncidencias();
                        } else if (this.pestana === "rentabilidad") {
                            this.cargarRentabilidad();
                        }
                    });
                })
                .catch(error => {
                    console.error(error);
                    swal({ title: this.$t("error"), text: this.$t("errorDesconocido"), type: "error" });
                })
                .finally(() => { this.cargando = false; this.consultado = true; });
        },

        cargarVentas() {
            if (!this.tieneDatos) return;
            this.cargandoVentas = true;
            const params = Object.assign(this.baseParams(false), { alinear: this.alinearSemana ? "diaSemana" : "diaMes" });
            this.axios.get(this.$store.getters.apiUrl + "analisisnegocio/getVentas", this.config(params))
                .then(response => {
                    this.ventas = (response.data && response.data.response) ? response.data.result : null;
                    this.$nextTick(() => { this.pintarDiario(); this.pintarSemana(); this.pintarHoras(); });
                })
                .catch(error => { console.error(error); this.ventas = null; })
                .finally(() => { this.cargandoVentas = false; });
        },

        cargarEvolucion() {
            if (!this.tieneDatos) return;
            this.cargandoEvolucion = true;
            this.axios.get(this.$store.getters.apiUrl + "analisisnegocio/getEvolucion", this.config(this.baseParams(false)))
                .then(response => {
                    this.evolucion = (response.data && response.data.response) ? (response.data.result.serie || []) : [];
                    this.$nextTick(this.pintarEvolucion);
                })
                .catch(error => { console.error(error); this.evolucion = []; })
                .finally(() => { this.cargandoEvolucion = false; });
        },

        cargarFormasPago() {
            if (!this.tieneDatos) return;
            this.cargandoFormasPago = true;
            this.axios.get(this.$store.getters.apiUrl + "analisisnegocio/getFormasPago", this.config(this.baseParams(false)))
                .then(response => {
                    this.formasPago = (response.data && response.data.response) ? response.data.result : null;
                    this.cargandoFormasPago = false;
                    this.$nextTick(this.pintarFormasPago);
                })
                .catch(error => { console.error(error); this.formasPago = null; this.cargandoFormasPago = false; });
        },

        cargarIncidencias() {
            if (!this.tieneDatos) return;
            this.cargandoIncidencias = true;
            const params = Object.assign(this.baseParams(false), { alinear: this.alinearSemana ? "diaSemana" : "diaMes" });
            this.axios.get(this.$store.getters.apiUrl + "analisisnegocio/getIncidencias", this.config(params))
                .then(response => {
                    this.incidencias = (response.data && response.data.response) ? response.data.result : null;
                    this.cargandoIncidencias = false;
                    this.$nextTick(this.pintarIncidencias);
                })
                .catch(error => { console.error(error); this.incidencias = null; this.cargandoIncidencias = false; });
        },

        cargarRentabilidad() {
            if (!this.tieneDatos) return;
            this.cargandoRentabilidad = true;
            const params = Object.assign(this.baseParams(false), { agrupar: this.agrupar });
            this.axios.get(this.$store.getters.apiUrl + "analisisnegocio/getRentabilidad", this.config(params))
                .then(response => {
                    this.rentabilidad = (response.data && response.data.response) ? response.data.result : null;
                    this.cargandoRentabilidad = false;
                    this.gamaOmnes = "total";
                    this.ajusteOmnes = 0;
                    this.$nextTick(this.pintarRentabilidad);
                })
                .catch(error => { console.error(error); this.rentabilidad = null; this.cargandoRentabilidad = false; });
        },

        cambiarAgrupacion(modo) {
            if (this.agrupar === modo) return;
            this.agrupar = modo;
            this.cargarRentabilidad();
        },

        /* Exporta la pestaña activa: PDF con sus gráficas (imágenes del canvas) y
           tablas, o Excel con una hoja por bloque. La API recibe los mismos filtros. */
        exportar(tipo) {
            if (this.exportando) return;
            if (!this.pestanaCargada) {
                swal({ title: this.$t("atencion"), text: this.$t("anExportarEsperaCarga"), type: "info" });
                return;
            }
            this.exportando = tipo;

            const graficasPorPestana = {
                ventas: [["evolucion", "anEvolucionMensual"], ["diario", "anVentasPorDia"], ["semana", "anVentasPorDiaSemana"], ["horas", "anVentasPorHora"]],
                formasPago: [["fpDonut", "anRepartoPorTipo"], ["fpTipos", "anTiposPorPeriodo"], ["fpEvolucion", "anEvolucionFormasPago"]],
                incidencias: [["incEvolucion", "anEvolucionIncidencias"], ["incDiario", "anIncidenciasPorDia"], ["incTipos", "anIncidenciasPorTipo"], ["incOperarios", "anIncidenciasPorOperario"], ["incProductos", "anIncidenciasPorProducto"]],
                rentabilidad: [["matriz", "anMatrizPopularidadMargen"], ["cuadrantes", "anMargenPorCuadrante"], ["topMargen", "anTopMargen"], ["omnes", "anAmplitudGama"]],
            };

            const graficas = [];
            if (tipo === "PDF") {
                (graficasPorPestana[this.pestana] || []).forEach(([nombre, clave]) => {
                    const g = this.graficas[nombre];
                    if (g && g.canvas) {
                        try {
                            const imagen = this.imagenGrafica(g.canvas);
                            graficas.push({ titulo: this.$t(clave), imagen: imagen.datos, ancho: imagen.ancho, alto: imagen.alto });
                        } catch (e) { console.error(e); }
                    }
                });
            }

            const params = Object.assign(this.baseParams(false), {
                alinear: this.alinearSemana ? "diaSemana" : "diaMes",
                agrupar: this.agrupar,
                graficas: JSON.stringify(graficas),
            });
            const cuerpo = new URLSearchParams();
            Object.keys(params).forEach(k => { if (params[k] !== undefined && params[k] !== null) cuerpo.append(k, params[k]); });

            this.axios.post(this.$store.getters.apiUrl + "analisisnegocio/exportAnalisis/" + this.pestana + "/" + tipo, cuerpo, {
                headers: { Authorization: "Bearer " + this.$store.getters.jwt, "Content-Type": "application/x-www-form-urlencoded" },
                responseType: "blob",
            })
                .then(response => {
                    const tipoMime = response.headers["content-type"] || "";
                    if (tipoMime.indexOf("json") !== -1) {
                        swal({ title: this.$t("atencion"), text: this.$t("errorDesconocido"), type: "warning" });
                        return;
                    }
                    const nombre = "analisis-negocio-" + this.pestana + "-" + (this.periodosSolicitados.desde || "").replace("-", "") + (tipo === "PDF" ? ".pdf" : ".xlsx");
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const enlace = document.createElement("a");
                    enlace.href = url;
                    enlace.download = nombre;
                    document.body.appendChild(enlace);
                    enlace.click();
                    document.body.removeChild(enlace);
                    window.URL.revokeObjectURL(url);
                })
                .catch(error => { console.error(error); swal({ title: this.$t("error"), text: this.$t("errorDesconocido"), type: "error" }); })
                .finally(() => { this.exportando = ""; });
        },

        /* El canvas de chart.js es transparente: se copia sobre fondo blanco y se manda en JPEG
           (Dompdf pinta mal los PNG con transparencia y el JPEG pesa una fracción). */
        imagenGrafica(canvas) {
            // Con pantallas retina el canvas dobla píxeles: se limita el ancho para aligerar la petición y Dompdf
            const escala = Math.min(1, 1400 / Math.max(1, canvas.width));
            const copia = document.createElement("canvas");
            copia.width = Math.round(canvas.width * escala);
            copia.height = Math.round(canvas.height * escala);
            const ctx = copia.getContext("2d");
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, copia.width, copia.height);
            ctx.drawImage(canvas, 0, 0, copia.width, copia.height);
            return { datos: copia.toDataURL("image/jpeg", 0.9), ancho: copia.width, alto: copia.height };
        },

        /* Borra la caché de los TPV y meses consultados y vuelve a calcular. */
        recalcular() {
            swal({
                title: this.$t("anRecalcular"),
                text: this.$t("anRecalcularConfirmacion"),
                type: "question",
                showCancelButton: true,
                confirmButtonText: this.$t("aceptar"),
                cancelButtonText: this.$t("salir"),
            }).then(res => {
                if (!res.value) return;
                this.recalculando = true;
                const params = this.baseParams(false);
                this.axios.post(this.$store.getters.apiUrl + "analisisnegocio/recalcular", params, { headers: { Authorization: "Bearer " + this.$store.getters.jwt } })
                    .then(response => {
                        const datos = response.data || {};
                        if (!datos.response) {
                            // Límite alcanzado (o error): la API dice cuánto falta
                            this.aplicarEstadoRecalculo(datos.result);
                            swal({ title: this.$t("atencion"), text: datos.message || this.$t("errorDesconocido"), type: "warning" });
                            return;
                        }
                        this.aplicarEstadoRecalculo(datos.result && datos.result.recalculo);
                        // La caché ya está borrada: la consulta normal vuelve a calcular
                        this.consultar(false);
                    })
                    .catch(error => console.error(error))
                    .finally(() => { this.recalculando = false; });
            }).catch(() => {});
        },

        /* Estado del límite de recálculo ({disponible, esperaSegundos, sinLimite}) → cuenta atrás. */
        aplicarEstadoRecalculo(estado) {
            const espera = estado && estado.esperaSegundos > 0 ? estado.esperaSegundos : 0;
            this.recalculoMotivo = espera > 0 && estado.motivo ? estado.motivo : "";
            this.ahora = Date.now();
            this.recalculoHasta = espera > 0 ? this.ahora + espera * 1000 : 0;
            this.pararRelojEspera();
            if (espera > 0) {
                this.relojEspera = setInterval(() => {
                    this.ahora = Date.now();
                    if (this.ahora >= this.recalculoHasta) this.pararRelojEspera();
                }, 15000);
            }
        },

        pararRelojEspera() {
            if (this.relojEspera) {
                clearInterval(this.relojEspera);
                this.relojEspera = null;
            }
        },

        /* ---------- Textos ---------- */

        textoPeriodo(desde, hasta, corte) {
            const d = moment(desde + "-01");
            const h = moment(hasta + "-01");
            let texto = d.format("MMM YYYY");
            if (desde !== hasta) texto += " – " + h.format("MMM YYYY");
            if (corte) texto += " (" + this.$t("anHasta") + " " + moment(corte).format("DD/MM") + ")";
            return texto;
        },

        etiquetaCorta(clave) {
            const p = this.periodos[clave];
            return p ? p.etiqueta : clave;
        },

        textoNota(nota) {
            if (nota === "distintaLongitud") return this.$t("anNotaDistintaLongitud");
            if (nota === "alineadoPorSemana") return this.$t("anNotaAlineadoSemana");
            if (nota.indexOf("bisiesto:") === 0) {
                const partes = nota.split(":");
                return this.$t("anNotaBisiesto", { periodo: this.etiquetaCorta(partes[1]), anio: partes[2] });
            }
            return nota;
        },

        formatear(valor, tipo) {
            if (valor === null || valor === undefined || valor === "") return "–";
            if (tipo === "importe") return Number(valor).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
            if (tipo === "entero") return Number(valor).toLocaleString("es-ES", { maximumFractionDigits: 0 });
            return String(valor);
        },

        formatearVariacion(v) {
            if (v === null || v === undefined) return "–";
            const signo = v > 0 ? "+" : "";
            return signo + Number(v).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " %";
        },

        variacionKpi(k, clave) {
            const c = this.comparativas[clave];
            return c && c[k.clave] ? c[k.clave].variacion : null;
        },

        /* Verde si mejora, rojo si empeora; en incidencias al revés. */
        claseVariacion(k, v) {
            if (v === null || v === undefined || Math.abs(v) < 0.005) return "an-var-neutra";
            const mejora = k.inverso ? v < 0 : v > 0;
            return mejora ? "an-var-mejora" : "an-var-empeora";
        },

        iconoVariacion(v) {
            if (v === null || v === undefined || Math.abs(v) < 0.005) return "fa-minus";
            return v > 0 ? "fa-arrow-up" : "fa-arrow-down";
        },

        /* ---------- Gráficas ---------- */

        destruirGraficas() {
            Object.keys(this.graficas).forEach(k => { if (this.graficas[k]) this.graficas[k].destroy(); });
            this.graficas = {};
        },

        redibujar() {
            Object.keys(this.graficas).forEach(k => { if (this.graficas[k]) this.graficas[k].resize(); });
        },

        crearGrafica(nombre, ref, configuracion) {
            if (this.graficas[nombre]) this.graficas[nombre].destroy();
            const canvas = this.$refs[ref];
            if (!canvas) return;
            configuracion.options = Object.assign({ maintainAspectRatio: false, responsive: true }, configuracion.options || {});
            this.graficas[nombre] = new Chart(canvas.getContext("2d"), configuracion);
        },

        formatoEje(tipo) {
            return v => tipo === "importe" ? Number(v).toLocaleString("es-ES", { maximumFractionDigits: 0 }) + " €" : Number(v).toLocaleString("es-ES");
        },

        tooltipImporte(tipo) {
            return (item, data) => {
                const ds = data.datasets[item.datasetIndex];
                const v = item.yLabel !== undefined ? item.yLabel : ds.data[item.index];
                return ds.label + ": " + this.formatear(v, tipo);
            };
        },

        pintarEvolucion() {
            if (!this.evolucion.length) return;
            const metrica = this.metricaEvolucion;
            const tipo = ["ventas", "ticketMedio", "mediaDiaria"].includes(metrica) ? "importe" : "entero";
            const etiquetas = this.evolucion.map(m => moment(m.clave + "-01").format("MMM YY"));
            const colores = this.evolucion.map(m => {
                if (m.enPeriodo.includes("A")) return COLORES.A.linea;
                if (m.enPeriodo.includes("B")) return COLORES.B.linea;
                if (m.enPeriodo.includes("C")) return COLORES.C.linea;
                return "rgba(30, 34, 170, 0.28)";
            });
            this.crearGrafica("evolucion", "canvasEvolucion", {
                type: "bar",
                data: { labels: etiquetas, datasets: [{ label: this.$t(metrica === "documentos" ? "numDocumentos" : (metrica === "mediaDiaria" ? "anMediaDiaria" : metrica)), data: this.evolucion.map(m => m[metrica] || 0), backgroundColor: colores }] },
                options: {
                    legend: { display: false },
                    scales: { yAxes: [{ ticks: { beginAtZero: true, callback: this.formatoEje(tipo) } }] },
                    tooltips: { callbacks: { label: this.tooltipImporte(tipo) } },
                },
            });
        },

        datasetsPeriodos(extraer, tipoGrafica) {
            return this.clavesPeriodos.map(clave => {
                const color = COLORES[clave] || COLORES.B;
                const base = { label: this.etiquetaCorta(clave), data: extraer(clave), borderColor: color.linea, backgroundColor: tipoGrafica === "bar" ? color.linea : color.relleno, borderWidth: 2 };
                if (tipoGrafica === "line") Object.assign(base, { fill: clave === "A", lineTension: 0.25, pointRadius: 2, spanGaps: false });
                return base;
            });
        },

        pintarDiario() {
            if (!this.ventas) return;
            const series = this.ventas.diarias;
            // Eje X: unión de las posiciones de todos los periodos (día del mes o día del periodo).
            const xs = {};
            this.clavesPeriodos.forEach(c => (series[c] || []).forEach(p => { xs[p.x] = true; }));
            const posiciones = Object.keys(xs).map(Number).sort((a, b) => a - b);
            const esSemana = this.ventas.alinear === "diaSemana";
            const etiquetas = posiciones.map(x => esSemana ? this.$t("anDia") + " " + x : String(x));
            this.crearGrafica("diario", "canvasDiario", {
                type: "line",
                data: {
                    labels: etiquetas,
                    datasets: this.datasetsPeriodos(clave => {
                        const porX = {};
                        (series[clave] || []).forEach(p => { porX[p.x] = p.ventas; });
                        return posiciones.map(x => porX[x] !== undefined ? porX[x] : null);
                    }, "line"),
                },
                options: {
                    legend: { position: "bottom" },
                    scales: { yAxes: [{ ticks: { beginAtZero: true, callback: this.formatoEje("importe") } }] },
                    tooltips: {
                        mode: "index", intersect: false,
                        callbacks: {
                            title: items => {
                                const x = posiciones[items[0].index];
                                return this.clavesPeriodos.map(c => {
                                    const p = (series[c] || []).find(q => q.x === x);
                                    return p ? this.etiquetaCorta(c) + ": " + moment(p.fecha).format("ddd DD/MM/YYYY") : null;
                                }).filter(Boolean).join("\n");
                            },
                            label: this.tooltipImporte("importe"),
                        },
                    },
                },
            });
        },

        pintarSemana() {
            if (!this.ventas) return;
            const nombres = [this.$t("lunes"), this.$t("martes"), this.$t("miercoles"), this.$t("jueves"), this.$t("viernes"), this.$t("sabado"), this.$t("domingo")];
            this.crearGrafica("semana", "canvasSemana", {
                type: "bar",
                data: { labels: nombres, datasets: this.datasetsPeriodos(clave => (this.ventas.diaSemana[clave] || []).map(d => d.media || 0), "bar") },
                options: {
                    legend: { position: "bottom" },
                    scales: { yAxes: [{ ticks: { beginAtZero: true, callback: this.formatoEje("importe") } }] },
                    tooltips: { callbacks: { label: this.tooltipImporte("importe") } },
                },
            });
        },

        etiquetaTipoPago(tipo) {
            const claves = { E: "formaPagoTipoEfectivo", T: "formaPagoTipoTarjeta", C: "formaPagoTipoCheque", O: "formaPagoTipoOtros", S: "formaPagoTipoSaldo" };
            return this.$t(claves[tipo] || "formaPagoTipoOtros");
        },

        etiquetaSpecial(st) {
            if (st === 1) return this.$t("pendiente");
            if (st === 2) return this.$t("cuentaCasa");
            if (st === 3) return this.$t("valeRegalo");
            return "";
        },

        formatearPct(v) {
            return Number(v).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " %";
        },

        formatearDecimal(v) {
            if (v === null || v === undefined) return "–";
            return Number(v).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },

        colorTipoPago(tipo) {
            return { E: "#2e7d32", T: "#1E22AA", C: "#e0a12a", O: "#7a82a8", S: "#5e35b1" }[tipo] || "#b0b4c6";
        },

        colorTipoIncidencia(tipo) {
            return {
                incidenciasPrecioModificado: "#b26a00", incidenciasLineaEliminada: "#c62828",
                incidenciasCantidadModificada: "#1565c0", incidenciasDescuentoModificado: "#5e35b1", incidenciasOtras: "#7a82a8",
            }[tipo] || "#b0b4c6";
        },

        nombreProductoIncidencia(nombre) {
            return nombre === "__otros__" ? this.$t("otros") : nombre;
        },

        /* ---------- Formas de pago ---------- */

        pintarFormasPago() {
            this.pintarFpDonut();
            this.pintarFpTipos();
            this.pintarFpEvolucion();
        },

        pintarFpDonut() {
            if (!this.formasPago) return;
            const tipos = Object.values(this.formasPago.reparto.A.tipos).filter(t => Math.abs(t.importe) >= 0.005);
            this.crearGrafica("fpDonut", "canvasFpDonut", {
                type: "doughnut",
                data: {
                    labels: tipos.map(t => this.etiquetaTipoPago(t.tipo)),
                    datasets: [{ data: tipos.map(t => Math.abs(t.importe)), backgroundColor: tipos.map(t => this.colorTipoPago(t.tipo)) }],
                },
                options: {
                    legend: { position: "bottom" },
                    tooltips: { callbacks: { label: (item, data) => {
                        const t = tipos[item.index];
                        return data.labels[item.index] + ": " + this.formatear(t.importe, "importe") + " (" + this.formatearPct(t.porcentaje) + ")";
                    } } },
                },
            });
        },

        pintarFpTipos() {
            if (!this.formasPago) return;
            const orden = ["E", "T", "C", "O", "S"];
            const presentes = orden.filter(tipo => this.clavesPeriodos.some(c => this.formasPago.reparto[c].tipos[tipo]));
            this.crearGrafica("fpTipos", "canvasFpTipos", {
                type: "bar",
                data: {
                    labels: presentes.map(t => this.etiquetaTipoPago(t)),
                    datasets: this.datasetsPeriodos(clave => presentes.map(t => (this.formasPago.reparto[clave].tipos[t] || {}).importe || 0), "bar"),
                },
                options: {
                    legend: { position: "bottom" },
                    scales: { yAxes: [{ ticks: { beginAtZero: true, callback: this.formatoEje("importe") } }] },
                    tooltips: { callbacks: { label: this.tooltipImporte("importe") } },
                },
            });
        },

        pintarFpEvolucion() {
            if (!this.formasPago) return;
            const evolucion = this.formasPago.evolucion;
            const orden = ["E", "T", "C", "O", "S"];
            const presentes = orden.filter(tipo => evolucion.some(m => m.tipos[tipo]));
            const pct = this.fpEvolucionPorcentaje;
            this.crearGrafica("fpEvolucion", "canvasFpEvolucion", {
                type: "bar",
                data: {
                    labels: evolucion.map(m => moment(m.clave + "-01").format("MMM YY")),
                    datasets: presentes.map(tipo => ({
                        label: this.etiquetaTipoPago(tipo),
                        backgroundColor: this.colorTipoPago(tipo),
                        data: evolucion.map(m => {
                            const v = m.tipos[tipo] || 0;
                            return pct ? (Math.abs(m.total) >= 0.005 ? Math.round(v / m.total * 10000) / 100 : 0) : v;
                        }),
                    })),
                },
                options: {
                    legend: { position: "bottom" },
                    scales: {
                        xAxes: [{ stacked: true }],
                        yAxes: [{ stacked: true, ticks: { beginAtZero: true, max: pct ? 100 : undefined, callback: pct ? (v => v + " %") : this.formatoEje("importe") } }],
                    },
                    tooltips: { mode: "index", callbacks: { label: (item, data) => {
                        const ds = data.datasets[item.datasetIndex];
                        return ds.label + ": " + (pct ? this.formatearPct(ds.data[item.index]) : this.formatear(ds.data[item.index], "importe"));
                    } } },
                },
            });
        },

        /* ---------- Incidencias ---------- */

        pintarIncidencias() {
            this.pintarIncEvolucion();
            this.pintarIncDiario();
            this.pintarIncTipos();
            this.pintarIncBarras("incOperarios", "canvasIncOperarios", this.incidencias.resumen.A.porOperario, "#c62828");
            this.pintarIncBarras("incProductos", "canvasIncProductos", this.incidencias.resumen.A.porProducto, "#b26a00");
        },

        pintarIncEvolucion() {
            const evolucion = this.incidencias.evolucion;
            const colores = evolucion.map(m => m.enPeriodo.includes("A") ? "#c62828" : (m.enPeriodo.length ? "#e57373" : "rgba(198, 40, 40, 0.3)"));
            this.crearGrafica("incEvolucion", "canvasIncEvolucion", {
                type: "bar",
                data: {
                    labels: evolucion.map(m => moment(m.clave + "-01").format("MMM YY")),
                    datasets: [
                        { type: "line", label: this.$t("anPor100Docs"), data: evolucion.map(m => m.ratio), borderColor: "#1E22AA", backgroundColor: "rgba(30,34,170,0.1)", fill: false, yAxisID: "ratio", lineTension: 0.25, pointRadius: 3 },
                        { label: this.$t("incidencias"), data: evolucion.map(m => m.incidencias), backgroundColor: colores, yAxisID: "total" },
                    ],
                },
                options: {
                    legend: { position: "bottom" },
                    scales: {
                        yAxes: [
                            { id: "total", position: "left", ticks: { beginAtZero: true, callback: this.formatoEje("entero") } },
                            { id: "ratio", position: "right", ticks: { beginAtZero: true }, gridLines: { drawOnChartArea: false }, scaleLabel: { display: true, labelString: this.$t("anPor100Docs") } },
                        ],
                    },
                    tooltips: { mode: "index" },
                },
            });
        },

        pintarIncDiario() {
            const series = this.incidencias.diarias;
            const xs = {};
            this.clavesPeriodos.forEach(c => (series[c] || []).forEach(p => { xs[p.x] = true; }));
            const posiciones = Object.keys(xs).map(Number).sort((a, b) => a - b);
            const esSemana = this.incidencias.alinear === "diaSemana";
            this.crearGrafica("incDiario", "canvasIncDiario", {
                type: "line",
                data: {
                    labels: posiciones.map(x => esSemana ? this.$t("anDia") + " " + x : String(x)),
                    datasets: this.datasetsPeriodos(clave => {
                        const porX = {};
                        (series[clave] || []).forEach(p => { porX[p.x] = p.incidencias; });
                        return posiciones.map(x => porX[x] !== undefined ? porX[x] : null);
                    }, "line"),
                },
                options: {
                    legend: { position: "bottom" },
                    scales: { yAxes: [{ ticks: { beginAtZero: true, callback: this.formatoEje("entero") } }] },
                    tooltips: {
                        mode: "index", intersect: false,
                        callbacks: {
                            title: items => {
                                const x = posiciones[items[0].index];
                                return this.clavesPeriodos.map(c => {
                                    const p = (series[c] || []).find(q => q.x === x);
                                    return p ? this.etiquetaCorta(c) + ": " + moment(p.fecha).format("ddd DD/MM/YYYY") : null;
                                }).filter(Boolean).join("\n");
                            },
                        },
                    },
                    // Pulsar un día abre el Cierre de caja Z de ese día con las incidencias desplegadas.
                    onClick: (evento, elementos) => {
                        if (!elementos.length) return;
                        const el = elementos[0];
                        const clave = this.clavesPeriodos[el._datasetIndex];
                        const punto = (series[clave] || []).find(q => q.x === posiciones[el._index]);
                        if (punto) this.abrirCierreZ(punto.fecha);
                    },
                },
            });
        },

        pintarIncTipos() {
            const tipos = ["incidenciasPrecioModificado", "incidenciasLineaEliminada", "incidenciasCantidadModificada", "incidenciasDescuentoModificado", "incidenciasOtras"]
                .filter(t => this.clavesPeriodos.some(c => (this.incidencias.resumen[c].porTipo[t] || 0) > 0));
            this.crearGrafica("incTipos", "canvasIncTipos", {
                type: "bar",
                data: {
                    labels: tipos.map(t => this.$t(t)),
                    datasets: this.datasetsPeriodos(clave => tipos.map(t => this.incidencias.resumen[clave].porTipo[t] || 0), "bar"),
                },
                options: {
                    legend: { position: "bottom" },
                    scales: { yAxes: [{ ticks: { beginAtZero: true, callback: this.formatoEje("entero") } }] },
                },
            });
        },

        pintarIncBarras(nombre, ref, lista, color) {
            const items = (lista || []).slice().reverse();
            this.crearGrafica(nombre, ref, {
                type: "horizontalBar",
                data: {
                    labels: items.map(i => this.nombreProductoIncidencia(i.nombre)),
                    datasets: [{ label: this.$t("incidencias"), data: items.map(i => i.n), backgroundColor: items.map(i => i.nombre === "__otros__" ? "#b0b4c6" : color) }],
                },
                options: {
                    legend: { display: false },
                    scales: { xAxes: [{ ticks: { beginAtZero: true, callback: this.formatoEje("entero") } }] },
                },
            });
        },

        /* ---------- Rentabilidad ---------- */

        etiquetaCuadrante(q) {
            return { lider: "anCuadranteLider", popular: "anCuadrantePopular", rentable: "anCuadranteRentable", revisar: "anCuadranteRevisar" }[q] || q;
        },

        colorCuadrante(q) {
            return { lider: "#2e7d32", popular: "#1E22AA", rentable: "#e0a12a", revisar: "#c62828" }[q] || "#b0b4c6";
        },

        formatearUds(v) {
            return Number(v || 0).toLocaleString("es-ES", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
        },

        ordenarItems(campo) {
            if (this.ordenItems.campo === campo) this.ordenItems.asc = !this.ordenItems.asc;
            else this.ordenItems = { campo: campo, asc: campo === "nombre" || campo === "categoria" || campo === "cuadrante" };
        },

        flechaOrden(campo) {
            if (this.ordenItems.campo !== campo) return "";
            return this.ordenItems.asc ? "▲" : "▼";
        },

        pintarRentabilidad() {
            this.pintarMatriz();
            this.pintarCuadrantes();
            this.pintarTopMargen();
            this.pintarOmnes();
        },

        /* Matriz popularidad × margen: una burbuja por ítem clasificado, tamaño según
           su MC total, color por cuadrante, y los dos umbrales pintados como líneas. */
        pintarMatriz() {
            if (!this.rentabilidad || this.pestana !== "rentabilidad") return;
            const items = this.itemsVista.filter(it => it.cuadrante);
            const maxMc = Math.max(1, ...items.map(it => Math.abs(it.mcTotal)));
            const umbrales = this.rentabilidad.umbrales;
            const porCuadrante = {};
            items.forEach(it => { (porCuadrante[it.cuadrante] = porCuadrante[it.cuadrante] || []).push(it); });
            const datasets = this.cuadrantes.filter(q => porCuadrante[q]).map(q => ({
                label: this.$t(this.etiquetaCuadrante(q)),
                backgroundColor: this.colorCuadrante(q) + "aa",
                borderColor: this.colorCuadrante(q),
                data: porCuadrante[q].map(it => ({ x: it.popularidad, y: it.mcUnitario, r: 4 + Math.sqrt(Math.abs(it.mcTotal) / maxMc) * 22, item: it })),
            }));
            const lineasUmbral = {
                afterDraw: chart => {
                    const ctx = chart.ctx, area = chart.chartArea;
                    const ejeX = chart.scales["x-axis-0"], ejeY = chart.scales["y-axis-0"];
                    if (!ejeX || !ejeY || umbrales.popularidad === null) return;
                    ctx.save();
                    ctx.setLineDash([6, 4]);
                    ctx.strokeStyle = "#7a82a8";
                    ctx.lineWidth = 1.5;
                    const px = ejeX.getPixelForValue(umbrales.popularidad);
                    const py = ejeY.getPixelForValue(umbrales.mcUnitario);
                    ctx.beginPath(); ctx.moveTo(px, area.top); ctx.lineTo(px, area.bottom); ctx.stroke();
                    ctx.beginPath(); ctx.moveTo(area.left, py); ctx.lineTo(area.right, py); ctx.stroke();
                    ctx.restore();
                },
            };
            this.crearGrafica("matriz", "canvasMatriz", {
                type: "bubble",
                data: { datasets: datasets },
                plugins: [lineasUmbral],
                options: {
                    legend: { position: "bottom" },
                    scales: {
                        xAxes: [{ scaleLabel: { display: true, labelString: this.$t("anIndicePopularidad") + " (%)" }, ticks: { beginAtZero: true } }],
                        yAxes: [{ scaleLabel: { display: true, labelString: this.$t("anMargenContribucion") + " (€)" } }],
                    },
                    tooltips: { callbacks: { label: item => {
                        const d = datasets[item.datasetIndex].data[item.index].item;
                        return (d.nombre + (d.nombreTarifa ? " · " + d.nombreTarifa : "")) + ": " + this.formatearDecimal(d.popularidad) + " % · MCU " + this.formatear(d.mcUnitario, "importe") + " · MC total " + this.formatear(d.mcTotal, "importe");
                    } } },
                },
            });
        },

        pintarCuadrantes() {
            const r = this.rentabilidad.resumen.cuadrantes;
            this.crearGrafica("cuadrantes", "canvasCuadrantes", {
                type: "bar",
                data: {
                    labels: this.cuadrantes.map(q => this.$t(this.etiquetaCuadrante(q))),
                    datasets: [{ label: this.$t("anMargenContribucionTotal"), data: this.cuadrantes.map(q => r[q].mcTotal), backgroundColor: this.cuadrantes.map(q => this.colorCuadrante(q)) }],
                },
                options: {
                    legend: { display: false },
                    scales: { yAxes: [{ ticks: { beginAtZero: true, callback: this.formatoEje("importe") } }] },
                    tooltips: { callbacks: { label: (item, data) => this.formatear(data.datasets[0].data[item.index], "importe") + " · " + r[this.cuadrantes[item.index]].items + " " + this.$t("anItems") } },
                },
            });
        },

        pintarTopMargen() {
            const top = this.rentabilidad.items.filter(it => it.mcTotal !== null).slice(0, 12).reverse();
            this.crearGrafica("topMargen", "canvasTopMargen", {
                type: "horizontalBar",
                data: {
                    labels: top.map(it => it.nombre + (it.nombreTarifa ? " · " + it.nombreTarifa : "")),
                    datasets: [{ label: this.$t("anMargenContribucionTotal"), data: top.map(it => it.mcTotal), backgroundColor: top.map(it => this.colorCuadrante(it.cuadrante)) }],
                },
                options: {
                    legend: { display: false },
                    scales: { xAxes: [{ ticks: { beginAtZero: true, callback: this.formatoEje("importe") } }] },
                    tooltips: { callbacks: { label: (item, data) => this.formatear(data.datasets[0].data[item.index], "importe") } },
                },
            });
        },

        pintarOmnes() {
            const g = this.omnesGama;
            if (!g || this.pestana !== "rentabilidad") return;
            const etiquetas = [this.$t("anBandaBaja"), this.$t("anBandaMedia"), this.$t("anBandaAlta")];
            this.crearGrafica("omnes", "canvasOmnes", {
                type: "bar",
                data: {
                    labels: etiquetas,
                    datasets: [
                        { label: this.$t("anActual"), data: [g.amplitud.porcentajes.baja, g.amplitud.porcentajes.media, g.amplitud.porcentajes.alta], backgroundColor: "#1E22AA" },
                        { label: this.$t("anIdeal"), data: [25, 50, 25], backgroundColor: "rgba(122, 130, 168, 0.45)" },
                    ],
                },
                options: {
                    legend: { position: "bottom" },
                    scales: { yAxes: [{ ticks: { beginAtZero: true, max: 100, callback: v => v + " %" } }] },
                    tooltips: { callbacks: { label: (item, data) => data.datasets[item.datasetIndex].label + ": " + this.formatearPct(data.datasets[item.datasetIndex].data[item.index]) + (item.datasetIndex === 0 ? " (" + [g.amplitud.bandas.baja, g.amplitud.bandas.media, g.amplitud.bandas.alta][item.index] + " " + this.$t("anItems") + ")" : "") } },
                },
            });
        },

        claseOmnesDispersion(g) {
            const c = g.dispersion.coeficiente;
            if (c === null || !g.dispersion.aplica) return "an-omnes-neutro";
            return (c >= 2.5 && c <= 3) ? "an-omnes-bien" : "an-omnes-mal";
        },

        claseOmnesRatio(ratio) {
            if (ratio === null) return "an-omnes-neutro";
            return (ratio >= 0.9 && ratio <= 1.0) ? "an-omnes-bien" : "an-omnes-mal";
        },

        textoRecomendacion(ratio) {
            if (ratio === null) return "";
            if (ratio > 1.0) return this.$t("anRecomendableSubir");
            if (ratio < 0.9) return this.$t("anRecomendableBajar");
            return this.$t("anRecomendableMantener");
        },

        abrirCierreZ(fecha) {
            const query = { fecha: fecha, idCompany: this.idCompany, seccion: "incidencias" };
            if (this.modoSectores) query.idSector = this.idSector; else if (this.idsBusiness.length) query.idsBusiness = this.idsBusiness.join(",");
            this.$router.push({ name: "cierre-caja-z", query: query });
        },

        pintarHoras() {
            if (!this.ventas) return;
            const etiquetas = [];
            for (let h = 0; h < 24; h++) etiquetas.push((h < 10 ? "0" : "") + h + ":00");
            this.crearGrafica("horas", "canvasHoras", {
                type: "line",
                data: { labels: etiquetas, datasets: this.datasetsPeriodos(clave => ((this.ventas.horas[clave] || {}).serie || []).map(h => h.ventas), "line") },
                options: {
                    legend: { position: "bottom" },
                    scales: { yAxes: [{ ticks: { beginAtZero: true, callback: this.formatoEje("importe") } }] },
                    tooltips: { mode: "index", intersect: false, callbacks: { label: this.tooltipImporte("importe") } },
                },
            });
        },
    },
};
</script>

<style scoped>
.card {
    padding: 16px 20px;
    margin-bottom: 14px;
    border: 1px solid #e4e7ee;
    border-radius: 8px;
    background: #fff;
}

/* Filtros: misma fila flex que Cierre Z */
.an-filtros-fila {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 12px 18px;
}

.an-filtro {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.an-filtros label {
    display: block;
    height: 18px;
    line-height: 18px;
    white-space: nowrap;
    margin-bottom: 4px;
    font-weight: 700;
    font-size: 0.78rem;
    color: #3c4166;
}

.an-filtro-empresa { flex: 1 1 170px; }
.an-filtro-negocios { flex: 2 1 240px; }
.an-filtro-modo { flex: 0 0 auto; }
.an-filtro-mes { flex: 0 0 170px; }
.an-filtro-comparar { flex: 0 0 240px; }
.an-filtro-rango { flex: 0 0 auto; }
.an-filtro-accion { flex: 0 0 auto; margin-left: auto; flex-direction: row; gap: 8px; }

.an-filtros .form-control,
.an-filtro-accion .btn,
.an-modo .btn {
    height: 40px;
    margin: 0;
}

.an-filtro-accion .btn {
    padding: 0 18px;
    line-height: 38px;
    white-space: nowrap;
}

.an-btn-recalcular {
    padding: 0 14px !important;
    color: #3b4a9c;
    white-space: nowrap;
}

.an-btn-recalcular-espera {
    color: #8a94a6;
}

.an-recalcular-espera {
    font-size: 12px;
}

.an-modo {
    display: flex;
}

.an-modo .btn {
    padding: 0 14px;
    line-height: 38px;
    font-size: 0.82rem;
}

.an-select {
    width: 100%;
}

.an-rango {
    display: flex;
    align-items: center;
    gap: 6px;
}

.an-rango input {
    flex: 1 1 140px;
    width: 150px;
    min-width: 0;
}

.an-nota {
    margin-top: 12px;
    padding: 8px 12px;
    border-radius: 6px;
    background: #f3f7fc;
    border: 1px solid #d6e4f5;
    border-left: 4px solid #4a7dbf;
    color: #2f4a6d;
    font-size: 0.82rem;
}

.an-nota i {
    margin-right: 6px;
}

.an-nota-aviso {
    background: #fff8e1;
    border-color: #f1e2a8;
    border-left-color: #e0a800;
    color: #8a6d1f;
}

.an-nota-error {
    background: #fff5f5;
    border-color: #f3c9c6;
    border-left-color: #d9534f;
    color: #b3261e;
}

.an-cargando {
    text-align: center;
    color: #5b6183;
    padding: 30px;
}

.an-cargando i {
    margin-right: 8px;
}

/* Vacío */
.an-vacio {
    text-align: center;
    padding: 36px 20px 30px;
}

.an-vacio-icono {
    width: 64px;
    height: 64px;
    margin: 0 auto 14px;
    border-radius: 50%;
    background: #eef0f7;
    color: #7a82a8;
    font-size: 1.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.an-vacio h4 {
    margin: 0 0 6px;
    font-size: 1.05rem;
    font-weight: 700;
    color: #3c4166;
}

.an-vacio p {
    margin: 0;
    color: #7a82a8;
    font-size: 0.88rem;
}

/* KPIs */
.an-kpis {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
    gap: 12px;
    margin-bottom: 14px;
}

.an-kpi {
    margin: 0;
    padding: 14px 16px;
}

.an-kpi-titulo {
    font-size: 0.74rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #7a82a8;
    font-weight: 700;
}

.an-kpi-valor {
    font-size: 1.45rem;
    font-weight: 700;
    color: #1e2535;
    margin: 4px 0 8px;
}

.an-kpi-comparativas {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.an-kpi-var {
    display: flex;
    align-items: baseline;
    gap: 6px;
    font-size: 0.78rem;
}

.an-kpi-var i {
    font-size: 0.68rem;
}

.an-kpi-var-valor {
    font-weight: 700;
    min-width: 62px;
}

.an-kpi-var-etiqueta {
    color: #7a82a8;
    font-size: 0.72rem;
}

.an-var-mejora { color: #2e7d32; }
.an-var-empeora { color: #c62828; }
.an-var-neutra { color: #7a82a8; }

.an-kpi-nota {
    margin-top: 6px;
    font-size: 0.7rem;
    color: #8d6e00;
}

/* Pestañas */
.an-pestanas-card {
    padding: 0;
}

.an-pestanas {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 2px;
    padding: 8px 12px 0;
    border-bottom: 1px solid #e4e7ee;
    background: #fafbfd;
    border-radius: 8px 8px 0 0;
}

.an-pestana {
    border: none;
    background: none;
    padding: 10px 16px;
    font-size: 0.86rem;
    font-weight: 600;
    color: #5b6183;
    border-bottom: 3px solid transparent;
    cursor: pointer;
    white-space: nowrap;
}

.an-pestana i {
    margin-right: 6px;
}

.an-pestana.activa {
    color: #1E22AA;
    border-bottom-color: #1E22AA;
}

.an-pestana:disabled {
    opacity: 0.45;
    cursor: default;
}

.an-exportar {
    margin-left: auto;
    display: flex;
    gap: 6px;
    align-items: center;
    padding-bottom: 6px;
}

.an-btn-pdf,
.an-btn-excel {
    color: #fff;
    border: none;
    font-weight: 600;
    height: 30px;
    margin: 0;
    padding: 0 12px;
    line-height: 30px;
    font-size: 0.78rem;
}

.an-btn-pdf i,
.an-btn-excel i {
    margin-right: 4px;
}

.an-btn-pdf { background: #c9463d; }
.an-btn-pdf:hover { background: #a83a32; color: #fff; }
.an-btn-excel { background: #1f7a45; }
.an-btn-excel:hover { background: #196238; color: #fff; }
.an-btn-inactivo { opacity: 0.55; }

.an-pestana-cuerpo {
    padding: 16px 20px 20px;
}

/* Gráficas */
.an-graficas {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
}

.an-grafica {
    border: 1px solid #e4e7ee;
    border-radius: 8px;
    padding: 12px 14px;
    background: #fff;
    min-width: 0;
}

.an-grafica-ancha {
    grid-column: 1 / -1;
}

.an-grafica-cabecera {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 8px;
}

.an-grafica-cabecera h5 {
    margin: 0;
    font-size: 0.92rem;
    font-weight: 700;
    color: #101255;
}

.an-grafica-cabecera small {
    font-weight: 400;
    margin-left: 6px;
}

.an-grafica-opciones .form-control {
    height: 30px;
    font-size: 0.8rem;
    padding: 2px 8px;
}

.an-check {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
    font-size: 0.82rem;
    color: #5b6183;
    cursor: pointer;
    margin: 0;
}

.an-canvas {
    position: relative;
    height: 300px;
}

.an-grafica-cargando {
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #7a82a8;
    font-size: 0.86rem;
}

.an-grafica-cargando i {
    margin-right: 8px;
}

.an-notas-grafica {
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.an-badge {
    display: inline-block;
    border-radius: 4px;
    padding: 1px 8px;
    font-size: 0.72rem;
    background: #fff8e1;
    color: #8d6e00;
    border: 1px solid #ffe082;
}

/* Tabla */
.an-titulo-tabla {
    margin: 22px 0 8px;
    font-size: 0.92rem;
    font-weight: 700;
    color: #101255;
}

.an-scroll {
    width: 100%;
    overflow-x: auto;
}

.an-tabla {
    font-size: 0.82rem;
    margin: 0;
}

.an-tabla th,
.an-tabla td {
    white-space: nowrap;
    vertical-align: middle;
}

.an-tabla th small {
    display: block;
    font-weight: 400;
    color: #7a82a8;
    font-size: 0.7rem;
}

.an-fila-sin-datos td {
    color: #b0b4c6;
}

.an-fila-total td {
    font-weight: 700;
    background: #eef0f7;
}

.an-fp-nivel-1 td {
    font-weight: 700;
}

.an-fp-nivel-2 td:first-child {
    padding-left: 28px;
    color: #5b6183;
}

.an-pct {
    color: #7a82a8;
    font-size: 0.78rem;
}

.an-badge-especial {
    background: #eef2ff;
    color: #3b4a9c;
    border-color: #d8ddf7;
    margin-left: 6px;
}

.an-pie {
    margin: 8px 0 0;
    font-size: 0.76rem;
    color: #7a82a8;
}

.an-nota-aviso {
    margin: 0 0 14px;
    background: #fff9ee;
    border-color: #f5dfb6;
    border-left-color: #e0a12a;
    color: #7a5a12;
}

.an-kpis-pestana {
    margin-bottom: 16px;
}

.an-kpi-valor small {
    font-size: 0.8rem;
    font-weight: 400;
    color: #7a82a8;
}

.an-kpi-sub {
    font-size: 0.78rem;
    color: #5b6183;
    margin-top: 2px;
}

/* Rentabilidad */
.an-controles {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
    margin: 0 0 14px;
}

.an-control {
    height: 34px;
    max-width: 240px;
    font-size: 0.84rem;
    padding: 4px 10px;
}

.an-control-inline {
    display: inline-block;
    width: auto;
    margin-left: 12px;
    vertical-align: middle;
}

.an-controles .an-modo .btn {
    height: 34px;
    line-height: 32px;
}

.an-kpi-cuadrante {
    border-top: 4px solid #b0b4c6;
}

.an-ayuda {
    color: #7a82a8;
    margin-left: 4px;
    cursor: help;
    font-weight: 400;
}

.an-canvas-alta {
    height: 420px;
}

.an-canvas-baja {
    height: 200px;
}

.an-cambios {
    margin-top: 6px;
}

.an-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.an-chip-cambio {
    display: inline-block;
    background: #fafbfd;
    border: 1px solid #e4e7ee;
    border-radius: 6px;
    padding: 4px 10px;
    font-size: 0.78rem;
    color: #3c4166;
}

.an-chip-cambio small {
    color: #7a82a8;
    margin-left: 4px;
}

.an-tabla-rent td {
    font-size: 0.8rem;
}

.an-ordenable {
    cursor: pointer;
    user-select: none;
}

.an-fila-sin-coste td {
    color: #8a90ad;
}

.an-badge-tarifa {
    background: #eef2ff;
    color: #3b4a9c;
    border-color: #d8ddf7;
    margin-left: 6px;
}

.an-badge-cuadrante {
    display: inline-block;
    color: #fff;
    border-radius: 4px;
    padding: 1px 8px;
    font-size: 0.72rem;
    font-weight: 700;
    white-space: nowrap;
}

.an-omnes {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px;
}

.an-omnes-valor {
    font-size: 2rem;
    font-weight: 700;
    margin: 6px 0;
}

.an-omnes-bien { color: #2e7d32; }
.an-omnes-mal { color: #c62828; }
.an-omnes-neutro { color: #5b6183; }

.an-omnes-texto {
    margin: 0 0 6px;
    font-size: 0.82rem;
    color: #3c4166;
}

.an-omnes-recomendacion {
    font-weight: 700;
}

.an-simulador label {
    display: block;
    font-size: 0.78rem;
    color: #5b6183;
    margin-bottom: 2px;
}

.an-simulador input[type="range"] {
    width: 100%;
}

@media (max-width: 991px) {
    .an-omnes {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 991px) {
    .an-graficas {
        grid-template-columns: 1fr;
    }

    .an-filtro,
    .an-filtro-accion {
        flex: 1 1 100%;
        margin-left: 0;
    }

    /* Los dos meses del rango se reparten la fila (con width 100% cada uno desbordaban) */
    .an-rango {
        width: 100%;
    }

    .an-rango input {
        flex: 1 1 0;
        width: auto;
    }
}

@media (max-width: 767px) {
    /* Exportar pasa a su propia fila bajo las pestañas, alineado a la derecha */
    .an-exportar {
        flex: 1 1 100%;
        margin-left: 0;
        justify-content: flex-end;
        padding: 6px 0 8px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/AnalisisNegocio.vue